class AlertService {

    constructor() {
        this.data = {
            templateId: "alertTemplate"
        }
        this._init();
    }

    showError(message) {
        this._showMessage(false, message);
    }

    showSuccess(message) {
        this._showMessage(true, message);
    }

    _showMessage(isSuccess, message) {
        $.fancybox.close();

        var $template = $(`#${this.data.templateId}`);

        var messageType = isSuccess ? "success" : "error";
        $template.find('.js-type').attr('class', `js-type custom-modal__message custom-modal__message--${messageType}`);

        $template.find('.js-icon').hide();
        $template.find(`.js-icon-${messageType}`).show();

        $template.find('.js-message').text(message);

        $.fancybox.open({ src: `#${this.data.templateId}`, modal: true });
    }

    _init() {
        const messageTemplate = `<div class="custom-modal" id="${this.data.templateId}" style="display: none;">
            <div class="custom-modal__message js-type" class="">
                <div class="custom-modal__message-icon-wrap">
                    <div class="custom-modal__message-icon-bg">
                        <svg class="custom-modal__message-icon js-icon js-icon-success">
                            <use xlink:href="~/m/i/icons.svg#symbol-checkbox-round"></use>
                        </svg>
                        <svg class="custom-modal__message-icon js-icon js-icon-error" icon="symbol-times">
                            <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                        </svg>
                    </div>
                </div>
                <h3 class="custom-modal__message-text js-message">[MESSAGE]</h3>
            </div>
            <a href="" data-fancybox-close class="custom-modal__close">
                <svg class="custom-modal__close-icon">
                    <use xlink:href="~/m/i/icons.svg#symbol-times"></use>
                </svg>
            </a>
        </div>`;

        $('body').append(messageTemplate);
    }
}

AlertService.shared = new AlertService();


class AnalyticsService {

    constructor() {

    }

    pushToTagManager(data) {
        if (!window.dataLayer) {
            console.error("dataLayer is not defined");
            return;
        }

        dataLayer.push(data)
    }
}

AnalyticsService.shared = new AnalyticsService();
class ApiService {
    constructor() {
    }


    _makeHttpDataPostRequest(baseUrl, endpointName, data) {
        var endpointUrl = baseUrl + endpointName;
        data.LanguageAbbr = SettingsService.shared.data.langAbbr;
        return new Promise((resolutionFunc, rejectionFunc) => {
            axios
                .post(endpointUrl, data)
                .then((response) => {
                    resolutionFunc(response.data)
                })
                .catch((error) => {
                    console.error(error);
                    var errorMessage = "apiresultcode_generalerror";
                    rejectionFunc({
                        code: -1,
                        message: errorMessage,
                        data: error.response.data
                    });
                });
        });
    }
    _makeHttpFilePostRequest(endpointName, file, fieldName, captchaToken) {
        
        var endpointUrl = SettingsService.shared.data.apiBaseUrl + endpointName;
        var formData = new FormData();
        formData.append("file", file);
        formData.append("fieldName", fieldName);
        formData.append("captchaToken", captchaToken);
     
        return new Promise((resolutionFunc, rejectionFunc) => {
            axios
                .post(endpointUrl, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    resolutionFunc(response.data)
                })
                .catch((error) => {
                    console.error(error);
                    var errorMessage = "apiresultcode_generalerror";
                    rejectionFunc({
                        code: -1,
                        message: errorMessage,
                        data: error.response.data
                    });
                });
        });
    }
}

ApiService.shared = new ApiService();
class PhrasesService {
    constructor() {
        this.phrases = {};

        if (!window._data.phrases) {
            return;
        }

        for (var i = 0; i < window._data.phrases.length; i++) {
            var phrase = window._data.phrases[i];
            this.phrases[phrase.T] = phrase.V;
        }
    }

    getPhrase(title) {
        if (!this.phrases[title]) {
            return title;
        }

        return this.phrases[title];
    }
}

PhrasesService.shared = new PhrasesService();
class SettingsService {

    constructor() {
        this.data = window._data;
    }
}

SettingsService.shared = new SettingsService();
class UrlsService {

    constructor() {
    }

    removeQueryParamFromUrl(url, param) {
        if (!param) {
            return url;
        }
        const [baseUrl, queryString] = url.split('?');
        const params = new URLSearchParams(queryString);

        if (params.has(param)) {
            params.delete(param);
        }

        const modifiedQueryString = params.toString();
        if (modifiedQueryString) {
            var modifiedUrl = `${baseUrl}?${modifiedQueryString}`;
            window.history.pushState('', '', modifiedUrl);
            return modifiedUrl;
        } else {
            window.history.pushState('', '', baseUrl);
            return baseUrl;
        }
    }
}

UrlsService.shared = new UrlsService();
Vue.filter("formatAmount", function (amountInCents) {
    var numValue = parseInt(amountInCents);
    var displayValue = (numValue / 100).toFixed(2);
    return displayValue;
  });
Vue.directive('inputMask', {
    bind: function (el, binding, vnode) {
        if (!binding.value)
            return;

        var maskOptions = {
            translation: {
                'X': {
                    pattern: /[a-zA-Z0-9А-Яа-я\\/\-ʻʼ' ]/,
                    recursive: true
                }
            },
            onChange: function (cep) {
                setTimeout(function () {
                    el.dispatchEvent(new CustomEvent('input'));
                });
            },
            onInvalid: function (val, e, f, invalid, options) {
                el.dispatchEvent(new CustomEvent('input'));

            }
        };

        var maskValue = binding.value;
        if (maskValue == 'money') {
            maskValue = "# ##0";
            maskOptions.reverse = true;
        }


        el.$_mask = $(el).mask(maskValue, maskOptions);
    },
    unbind: function (el, binding, vnode) {
        if (!!el.$_mask)
            el.$_mask.remove();
    }
});
Vue.component('campaign-donation-box', {
        props: {
            allocationDefaultPercent: Number,
            currentUserEmail: String,
            projectId: Number,
            isUserAuthorized: Boolean,
            checkoutUrl: String,
            hasAuthorizedUserFullAccess: Boolean
        },
        data: function () {
            return {
                signInUrl: SettingsService.shared.data.signInUrl,
                campaignUrl: SettingsService.shared.data.campaignUrl,
                product: SettingsService.shared.data.product,
                apiBaseUrl: SettingsService.shared.data.apiBaseUrl,
                identityBaseUrl: SettingsService.shared.data.identityBaseUrl,
                projects: SettingsService.shared.data.projects,
                campaignProject: SettingsService.shared.data.campaignProject,
                activeTab: 0,
                administrativeTip: null,
                email: { value: null, error: null },
                fullname: { value: null, error: null },
                marketingEmail: {value: null, error: null},
                isAnonymous: false,
                checkedProjectId: null,
                state: {
                    currentStep: null,
                    steps: [
                        {
                            id: 10
                        },
                        {
                            id: 20,
                        },
                    ]
                },
                phrases: {
                    allocationHintPhrase: PhrasesService.shared.getPhrase('donation_allocationhint'),
                    legendTextPhrase: PhrasesService.shared.getPhrase('donation_legend'),
                    allocationTitlePhrase: PhrasesService.shared.getPhrase('donation_allocationtitle'),
                    emailTextPhrase: PhrasesService.shared.getPhrase('donation_emailtext'),
                    donateAnonymouslyPhrase: PhrasesService.shared.getPhrase('donation_donateanonymously'),
                    donateButtonTitlePhrase: PhrasesService.shared.getPhrase('donation_donatebuttontitle'),
                    backButton: PhrasesService.shared.getPhrase('donation_backbutton'),
                    youAreDonating: PhrasesService.shared.getPhrase('donation_youaredonating'),
                    email: PhrasesService.shared.getPhrase('donation_email'),
                    fullname: PhrasesService.shared.getPhrase('donation_fullname'),
                    emailNotValid: PhrasesService.shared.getPhrase('donation_emailnotvalid'),
                    countryDescriptionPhrase: PhrasesService.shared.getPhrase('donation_countrydescription'),
                    onetimeGiveInternetButtonPhrase: PhrasesService.shared.getPhrase('donation_onetimegiveinternetbuttontitle'),
                    donateOnetimeTitlePhrase: PhrasesService.shared.getPhrase('donation_donateonetimetitle'),
                    donateCryptoUrlPhrase: PhrasesService.shared.getPhrase('donation_donatecryptourl'),
                    donateCryptoUrlTitlePhrase: PhrasesService.shared.getPhrase('donation_donatecryptourltitle'),
                },
                sendingData: false,
                showGeneralErrorMessage: false,
                generalErrorMessage: null,
                campaign: SettingsService.shared.data.campaign,
                showSignInButton: false
            }
        },
        methods: {
            getOneTimeDonationProducts() {
                var _this = this;
                return _this.product;
            },
            getGiveInternetButtonTitle() {
                var _this = this;
                var html = `<span class="\donation-box__total-payment\">${_this.formatAmount(_this.totalAmount)}</span>`;
                return _this.replaceAmountStr(_this.phrases.onetimeGiveInternetButtonPhrase, html);
            },
            getDonatingAmountTitle() {
                var _this = this;
                return _this.replaceAmountStr(_this.phrases.donateOnetimeTitlePhrase, _this.formatAmount(_this.totalAmount));
            },
            replaceAmountStr(phrase, amount) {
                var replacedPhrase = '';
                if (phrase)
                    replacedPhrase = phrase.replace('[amount]', amount);

                return replacedPhrase;
            },
            formatAmount(amount) {
                return amount.toFixed(2);
            },
            getCurrentStepIndex(stepId) {
                var _this = this;
                var index = _this.state.steps.map(function (e) {
                    return e.id;
                }).indexOf(stepId);
                return index;
            },
            showStep(stepId) {
                var _this = this;

                return !!_this.state.currentStep
                    && _this.state.currentStep.id == stepId
            },
            goNext() {
                var _this = this;
                if (!_this.state.currentStep)
                    return;
                var index = _this.getCurrentStepIndex(_this.state.currentStep.id);
                _this.state.currentStep = _this.state.steps[index + 1];
            },
            redirectToSignIn() {
                var _this = this;
                var queryParams = '?c=' + _this.campaign.Id + '&g=' + _this.campaign.PublicId;
                var returnUrl = encodeURIComponent(_this.campaignUrl + queryParams);
                window.location.href = _this.signInUrl + '?ReturnUrl=' + returnUrl;
            },
            goBack() {
                var _this = this;
                _this.resetGeneralErrorMessage();
                var index = _this.getCurrentStepIndex(_this.state.currentStep.id);
                _this.state.currentStep = _this.state.steps[index - 1];
            },
            validateEmail(email, isRequired) {
                var _this = this;
                var isEmailValid = false;
                email.error = null;
                if (!email.value && !isRequired) {
                    return true;
                }

                if (!email.value) {
                    email.error = "Email is required";
                    return isEmailValid;
                }

                isEmailValid = (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(email.value);
                if (!isEmailValid) {
                    email.error = _this.phrases.emailNotValid;
                    return;
                }

                return isEmailValid;
            },
            validateFullname(fullname) {
                var isValid = false;
                fullname.error = null
                if (!fullname.value) {
                    fullname.error = "Name is required";
                    return isValid;
                }

                return true;
            },
            getPostData(captchaToken) {
                var _this = this;
                var paymentTerm = 2;
                var products = [];

                if (!_this.validateEmail(_this.marketingEmail, false))
                    return;

                if (!_this.hasAuthorizedUserFullAccess)
                    _this.isAnonymous = true;

                products.push({
                    ProductId: _this.product.ProductId,
                    ItemQuantity: parseInt(_this.product.Quantity),
                    ItemAmount: parseInt(_this.product.Amount)
                });
                var data = {
                    ProjectId: _this.checkedProjectId,
                    AdministrativeTip: _this.administrativeTip,
                    PaymentTerm: paymentTerm,
                    MarketingEmail: _this.marketingEmail.value,
                    IsAnonymous: _this.isAnonymous,
                    Products: products,
                    captchaToken: captchaToken,
                    campaignId: _this.campaign.Id,
                    campaignPublicId: _this.campaign.PublicId
                };
                return data;
            },
            resetGeneralErrorMessage() {
                var _this = this;
                _this.showGeneralErrorMessage = false;
                _this.generalErrorMessage = null;
            },
            showErrorMessage(message, showbutton) {
                var _this = this;
                _this.showGeneralErrorMessage = true;
                _this.generalErrorMessage = message;
                _this.showSignInButton = showbutton;
            },
            getProgramDescription() {
                var _this = this;
                var projectTitle = _this.campaignProject.IsGeneralFund ? _this.campaignProject.Title : _this.campaignProject.CountryTitle;
                return _this.phrases.countryDescriptionPhrase.replace('[country]', projectTitle);
            },
            initSlider() {
                var _this = this;
                var allocationrange = _this.$refs.allocationrange;
                noUiSlider.create(allocationrange, {
                    connect: [true, false],
                    start: [_this.administrativeTip],
                    step: 5,
                    range: {
                        'min': [0],
                        'max': [100]
                    }
                });
                allocationrange.noUiSlider.on('update', function (values, handle) {
                    _this.administrativeTip = parseFloat(values[handle]);
                });
            },
            async donate() {
                var _this = this;
                if (_this.sendingData) return;
                var captchaToken = await window._executeRecaptcha();

                _this.resetGeneralErrorMessage();
                var data = _this.getPostData(captchaToken);
                if (!data) {
                    _this.sendingData = false;
                    return;
                }

                _this.sendingData = true;
                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'donation/createdonation', data)
                    .then((result) => {
                        if (result.success) {
                            window.location.href = _this.checkoutUrl + '?id=' + result.data.id + '&' + 'publicId=' + result.data.publicId;
                        }
                    })
                    .catch((error) => {
                        _this.sendingData = false;
                        _this.showGeneralErrorMessage = true;
                        _this.generalErrorMessage = error.data.message
                    });
            },
            async createAnonymousUser() {
                var _this = this;
                if (_this.sendingData) return;
                _this.resetGeneralErrorMessage();
                var isEmailValid = _this.validateEmail(_this.email, true);
                var isFullNameValid = _this.validateFullname(_this.fullname)
                if (!isEmailValid || !isFullNameValid) {
                    return;
                }

                var data = {
                    fullname: _this.fullname.value,
                    email: _this.email.value
                };
                _this.sendingData = true;
                ApiService.shared._makeHttpDataPostRequest(_this.identityBaseUrl,'user/createAnonymousUser', data)
                    .then((result) => {
                        _this.sendingData = false;
                        if (result.data && result.data.userAlreadyExist) {
                            this.showErrorMessage(result.message, true);
                            return;
                        }

                        if (result.succeeded) {
                            this.donate();
                        }
                    })
                    .catch((error) => {
                        _this.sendingData = false;
                        _this.showErrorMessage(error.data.message);
                    });
            }
        },
        mounted() {
            var _this = this;
            _this.state.currentStep = _this.state.steps[0];
            _this.administrativeTip = parseInt(_this.allocationDefaultPercent);

            if (_this.isUserAuthorized && _this.hasAuthorizedUserFullAccess) {
                _this.marketingEmail.value = _this.currentUserEmail;
            }

            setTimeout(function () {
                _this.initSlider();
            });
        },
        computed: {
            totalAmount() {
                var _this = this;
                var totalAmount = _this.totalDonationAmount + (_this.totalDonationAmount * _this.administrativeTip / 100);
                return totalAmount;
            },
            totalDonationAmount() {
                var _this = this;
                var donationProductTotal = _this.product.Quantity * _this.product.Amount;
                return donationProductTotal;
            }
        }
    ,
template: `
    <div class="donation-box">
        <!--Step 10-->
        <div class="donation-box__content" v-show="showStep(10)">
            <div class="donation-tabs__body tab-content" id="donation-tabs-content">
                <!--OneTime-->
                <h3 class="donation-onetime__title">{{campaign.ShortDescription}}</h3>
                <div class="donation-tabs__content tab-pane fade show active"
                     id="donationOnetime"
                     aria-labelledby="donationOnetime-link">

                    <!--Animation-->
                    <donation-animation></donation-animation>
                    
                    <!--Products-->
                    <donation-product :product="product"
                                      :show-any-amount-option="true">
                    </donation-product>
                </div>
            </div>
            <div class="donation-drag">
                <h4 class="donation-drag__title">
                    {{phrases.allocationTitlePhrase}} <span>+{{administrativeTip}}%</span>
                    <div class="donation-options__single-info-wrap">
                        <svg-icon class="donation-options__single-info-icon" icon="symbol-info"></svg-icon>
                        <div class="donation-options__single-info">
                            <div class="donation-options__single-info-clipboard"></div>
                            <p>{{phrases.allocationHintPhrase}}</p>
                        </div>
                    </div>
                </h4>
                <div class="donation-drag__slider-wrap">
                    <div ref="startValue" class="donation-drag__slider-value donation-drag__slider-value--start" id="startValue"><span ref="span">0%</span></div>
                    <div ref="allocationrange" class="donation-drag__slider" id="allocationrange"></div>
                    <div ref="endValue" class="donation-drag__slider-value donation-drag__slider-value--end" id="endValue"><span ref="span">100%</span></div>
                </div>
            </div>
            <div class="donation-actions">
                <a href="" @click.prevent="goNext(20)" class="button-action button-action--primary button-action--medium" v-html="getGiveInternetButtonTitle()"></a>
                <donation-credit-card-info :show-pay-pal-card="true"></donation-credit-card-info>
                <p class="donation-actions__additional">
                    {{getProgramDescription()}}
                </p>
            </div>
            <donation-footer></donation-footer>
        </div>
        <!--Step 20-->
        <div class="donation-box__content" v-show="showStep(20)">
            <div class="donation-box__back">
                <a @click.prevent="goBack()" href="" class="button-link button-link--default">Back</a>
            </div>
            <div class="donation-pay">
                <div class="donation-pay__text donation-pay__text--bottombordered">
                    <p class="donation-pay__title">{{phrases.youAreDonating}}</p>
                    <p class="donation-pay__amount" v-html="getDonatingAmountTitle()">
                    </p>
                </div>
                <div class="form">
                    <div class="form__group"
                         v-if="!hasAuthorizedUserFullAccess"
                         v-bind:class="{'has-error' : !!fullname.error}">
                        <label for="" class="form__label">{{phrases.fullname}}</label>
                        <div class="form__content">
                            <input v-model="fullname.value" type="text" class="form__element form__element--input" value="{{fullname.value}}">
                        </div>
                        <p class="form__error-text">{{fullname.error}}</p>
                    </div>
                    <div class="form__group"
                         v-if="!hasAuthorizedUserFullAccess"
                         v-bind:class="{'has-error' : !!email.error}">
                        <label for="" class="form__label">{{phrases.email}}</label>
                        <div class="form__content">
                            <input v-model="email.value" type="text" class="form__element form__element--input" value="{{email.value}}">
                        </div>
                        <p class="form__error-text">{{email.error}}</p>
                    </div>
                    <div class="form__group" 
                         v-if="hasAuthorizedUserFullAccess"
                         v-bind:class="{'has-error' : !!marketingEmail.error}">
                        <label for="" class="form__label">{{phrases.email}}</label>
                        <div class="form__content">
                            <input v-model="marketingEmail.value" type="text" class="form__element form__element--input" value="{{marketingEmail.value}}">
                        </div>
                        <p class="form__error-text">{{marketingEmail.error}}</p>
                    </div>
                    <div class="form__info">
                        <div class="form__info-icon-wrap">
                            <svg-icon class="form__info-icon" icon="symbol-info"></svg-icon>
                        </div>
                        <div class="form__info-text-wrap">
                            <p class="form__info-text" v-html="phrases.emailTextPhrase"></p>
                        </div>
                    </div>
                    <div class="form__options" v-if="isUserAuthorized">
                        <div class="custom-checkbox" 
                             v-if="hasAuthorizedUserFullAccess">
                            <input v-model="isAnonymous" type="checkbox" class="custom-checkbox__input" id="pc1" name="pc1" value="{{isAnonymous}}">
                            <label for="pc1" class="custom-checkbox__label">
                                <span class="custom-checkbox__icon-wrap">
                                    <svg-icon class="custom-checkbox__icon" icon="symbol-checkbox-round"></svg-icon>
                                </span>
                                <span class="custom-checkbox__text">{{phrases.donateAnonymouslyPhrase}}</span>
                            </label>
                        </div>

                    </div>
                    <div class="form__action">
                        <a href="" @click.prevent="isUserAuthorized && hasAuthorizedUserFullAccess? donate() : createAnonymousUser()" class="button-action button-action--primary button-action--large"
                           v-bind:class="{'loading' : sendingData }">
                            <div class="spinner"></div>
                            {{phrases.donateButtonTitlePhrase}}
                        </a>
                    </div>
                    <div class="auth__message auth__message--error" v-show="showGeneralErrorMessage">
                        <div class="auth__message-icon-wrap">
                            <svg-icon class="auth__message-icon" icon="symbol-times"></svg-icon>
                        </div>
                        <div class="auth__message-text-wrap">
                            <p class="auth__message-text js-message-text">
                                {{generalErrorMessage}}
                                <a href="" v-show="showSignInButton" @click.prevent="redirectToSignIn()" class="button-link button-link--primary">
                                   Sign in
                                </a>
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--legend-->
        <p class="donation-legend">
            <svg-icon class="donation-legend__icon" icon="symbol-lock"></svg-icon>
            <span class="donation-legend__text">{{phrases.legendTextPhrase}}</span>
        </p>
    </div>
`
});
Vue.component('damage-calculator', {
        props: ['countryPhrase', 'daysAffectedPhrase', 'totalCostImpactPhrase', 'peopleWithoutInternetPhrase'],
        data: function () {
            return {
                daysAffectedCount: 1,
                countries: null,
                checkedCountryName: '',
                selectedCountry: {},
                selectedCountryLabel: '',
                defaultvalue: ''
            };
        },
        methods: {
            plus() {
                var _this = this;
                if (_this.daysAffectedCount == 365)
                    return;
                _this.daysAffectedCount += 1;
            },
            minus() {
                var _this = this;
                if (_this.daysAffectedCount == 1)
                    return;

                _this.daysAffectedCount -= 1;
            },
            formatNumber(number) {
                return Math.round(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            isNumber(event) {
                var keyCode = (event.which) ? event.which : event.keyCode;
                if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
                    event.preventDefault();
                } else {
                    return true;
                }
            },
            checkCount() {
                var _this = this;
                var value = parseInt(_this.daysAffectedCount);
                if (value < 0) {
                    _this.daysAffectedCount = 1;
                } else if (value > 365) {
                    _this.daysAffectedCount = 365
                }
                _this.daysAffectedCount = Math.min(365, Math.max(1, _this.daysAffectedCount));
            },
            selectionTemplate(selection) {
                if (!selection.id) {
                    return selection.text;
                }
                var selection = $('<span class="custom-selection">' + selection.text + '</span>');
                return selection;
            }

        },
        mounted() {
            var _this = this;
            fetch('~/m/d/country-data.json')
                .then(response => {
                    if (!response.ok) {
                        throw new Error("HTTP error " + response.status);
                    }
                    return response.json();
                }).then(countries => {
                    _this.countries = countries;
                    _this.selectedCountry = countries[82];
                    _this.selectedCountryLabel = _this.selectedCountry.label;
                    _this.defaultvalue = _this.selectedCountryLabel;

                    $(_this.$refs.selector)
                        .select2({
                            maximumSelectionLength: 1,
                            multiple: true,
                            placeholder: 'Select a country',
                        })
                        .on('change', function (event) {
                            _this.selectedCountry = _this.countries.find(c => c.label == event.target.value);
                        })
                        ;

                    setTimeout(function () {
                        $(_this.$refs.selector).val([_this.selectedCountryLabel]).trigger('change');
                    }, 100);
                })
                .catch(function () {
                })

            $(_this.$refs.selector).on('select2:open', () => {
                $(_this.$refs.selector).val(null).trigger('change');
            });

            $(_this.$refs.selector).on('select2:closing', () => {
                var selectedValue = $(_this.$refs.selector).val();
                if (selectedValue == null || selectedValue.length == 0) {
                    $(_this.$refs.selector).val([_this.selectedCountryLabel]).trigger('change');
                }
            });

            $(_this.$refs.selector).on('select2:close', function (e) {
                setTimeout(() => {
                    $('.select2-container-active').removeClass('select2-container-active');
                    $(':focus').blur(); 
                },1);
            });
        },
        computed: {
            totalCostImpact() {
                var _this = this;
                if (!_this.selectedCountry)
                    return;

                if (_this.selectedCountry)
                    return _this.formatNumber(_this.selectedCountry.cost * _this.daysAffectedCount);
            },
            peopleWithoutInternet() {
                var _this = this;
                if (_this.selectedCountry) {
                    var usersWithoutInternet = _this.selectedCountry.users_without_internet;
                    if (!usersWithoutInternet) {
                        var population = _this.selectedCountry.pop;
                        var netUsers = population * _this.selectedCountry.net_users;
                        usersWithoutInternet = population - netUsers;
                    }
                    return _this.formatNumber(usersWithoutInternet);
                }
            }
        }
    ,
template: `
    <div class="calculator-card__body">
        <div class="calculator-card__dc">
            <div class="calculator-card__dc-item calculator-card__dc-item--dropdown">
                <h6 class="calculator-card__dc-item-title">{{countryPhrase}}</h6>
                <select ref="selector" id="dmg-country-list" name="countries" class="custom-select2 js-select2-mask">
                    <option v-for="country in countries">{{country.label}}</option>
                </select>
                <!--<div class="custom-select2__icon-wrap">
                    <svg class="custom-dropdown__trigger-icon">
                        <use xlink:href="~/m/i/icons.svg#symbol-caret"></use>
                    </svg>
                </div>-->
            </div>
            <div class="calculator-card__dc-item calculator-card__dc-item--calculator">
                <h6 class="calculator-card__dc-item-title">{{daysAffectedPhrase}}</h6>
                <div class="calculator-card__calculator">
                    <a href="" @click.prevent="minus" class="calculator-card__calculator-action js-calculator-minus">
                        <svg class="calculator-card__calculator-icon calculator-card__calculator-icon--minus">
                            <use xlink:href="~/m/i/icons.svg#symbol-minus"></use>
                        </svg>
                    </a>
                    <input class="calculator-card__calculator-amount"
                           maxlength="3"
                           v-model="daysAffectedCount"
                           @keypress="isNumber($event)"
                           @blur="checkCount()"
                           @input=" daysAffectedCount ? checkCount() : null" />
                    <a href="" @click.prevent="plus" class="calculator-card__calculator-action js-calculator-plus">
                        <svg class="calculator-card__calculator-icon calculator-card__calculator-icon--plus">
                            <use xlink:href="~/m/i/icons.svg#symbol-plus"></use>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="calculator-card__dc-item">
                <h6 class="calculator-card__dc-item-title">{{totalCostImpactPhrase}}</h6>
                <div class="calculator-card__dc-item-amount">
                    <p>$\{{totalCostImpact}}</p>
                </div>
            </div>
            <div class="calculator-card__dc-item">
                <h6 class="calculator-card__dc-item-title">{{peopleWithoutInternetPhrase}}</h6>
                <div class="calculator-card__dc-item-amount">
                    <p>{{peopleWithoutInternet}}</p>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('donation-animation', {
        props: [],
        data: function () {
            return {
            }
        },
        methods: {
        },
        mounted() {
        },
        computed: {
        }
    ,
template: `
    <div class="donation-animation">
        <img class="donation-animation__media donation-animation__media--laptop" src="~/m/i/laptop-f-animation-v1.svg" alt="" />
        <div class="donation-animation__dots">
            <span class="donation-animation__dot"></span>
            <span class="donation-animation__dot"></span>
            <span class="donation-animation__dot"></span>
            <span class="donation-animation__dot"></span>
            <span class="donation-animation__dot"></span>
        </div>
        <img class="donation-animation__media donation-animation__media--kids" src="~/m/i/kids-f-animation-v1.svg" alt="" />
    </div>
`
});
Vue.component('donation-box', {
        props: {
            allocationDefaultPercent: Number,
            currentUserEmail: String,
            projectId: Number,
            isUserAuthorized: Boolean,
            isUserStatusActive: Boolean,
            checkoutUrl: String,
            isProjectSelectedByUser: Boolean,
            activeTab: Number,
            showAnyAmountOption: Boolean,
            showUserInfoStep: Boolean,
            hasAuthorizedUserFullAccess: Boolean,
            productQuantity: Number,
            showLaptopStundetsIcon: Boolean,
        },
        data: function () {
            return {
                apiBaseUrl: SettingsService.shared.data.apiBaseUrl,
                identityBaseUrl: SettingsService.shared.data.identityBaseUrl,
                signInUrl: SettingsService.shared.data.signInUrl,
                donateUrl: SettingsService.shared.data.donateUrl,
                products: SettingsService.shared.data.products,
                projects: SettingsService.shared.data.projects,
                selectedMonthlyProducts: {},
                administrativeTip: null,
                email: { value: null, error: null },
                fullname: { value: null, error: null },
                marketingEmail: { value: null, error: null },
                isAnonymous: false,
                checkedProjectId: null,
                state: {
                    currentStep: null,
                    steps: [
                        {
                            id: 10
                        },
                        {
                            id: 20,
                        },
                    ]
                },
                phrases: {
                    monthlyTabTitlePhrase: PhrasesService.shared.getPhrase('donation_monthlytabtitle'),
                    bundleTabTitlePhrase: PhrasesService.shared.getPhrase('donation_bundletabtitle'),
                    allocationHintPhrase: PhrasesService.shared.getPhrase('donation_allocationhint'),
                    bundleDescriptionPhrase: PhrasesService.shared.getPhrase('donation_bundledescription'),
                    totalAmountMonthlyPhrase: PhrasesService.shared.getPhrase('donation_totalamountmonthly'),
                    totalAmountBundlePhrase: PhrasesService.shared.getPhrase('donation_totalamountbundle'),
                    monthlyGiveInternetButtonPhrase: PhrasesService.shared.getPhrase('donation_monthlygiveinternetbuttontitle'),
                    bundleGiveInternetButtonPhrase: PhrasesService.shared.getPhrase('donation_bundlegiveinternetbuttontitle'),
                    legendTextPhrase: PhrasesService.shared.getPhrase('donation_legend'),
                    allocationTitlePhrase: PhrasesService.shared.getPhrase('donation_allocationtitle'),
                    anyAmountTextPhrase: PhrasesService.shared.getPhrase('donation_anyamounttext'),
                    anyAmountUrlTitlePhrase: PhrasesService.shared.getPhrase('donation_anyamounturltitle'),
                    emailTextPhrase: PhrasesService.shared.getPhrase('donation_emailtext'),
                    donateAnonymouslyPhrase: PhrasesService.shared.getPhrase('donation_donateanonymously'),
                    donateButtonTitlePhrase: PhrasesService.shared.getPhrase('donation_donatebuttontitle'),
                    donateMonthlyTitlePhrase: PhrasesService.shared.getPhrase('donation_donatemonthlytitle'),
                    donateBundleTitlePhrase: PhrasesService.shared.getPhrase('donation_donatebundletitle'),
                    specificCountryDescriptionPhrase: PhrasesService.shared.getPhrase('donation_specificcountrydescription'),
                    specificCountryUrlPhrase: PhrasesService.shared.getPhrase('donation_specificcountryurl'),
                    backButton: PhrasesService.shared.getPhrase('donation_backbutton'),
                    youAreDonating: PhrasesService.shared.getPhrase('donation_youaredonating'),
                    email: PhrasesService.shared.getPhrase('donation_email'),
                    fullname: PhrasesService.shared.getPhrase('donation_fullname'),
                    emailNotValid: PhrasesService.shared.getPhrase('donation_emailnotvalid'),
                    selectProgramTitle: PhrasesService.shared.getPhrase('donation_selectprogramtitle'),
                    selectProgramButton: PhrasesService.shared.getPhrase('donation_selectprogrambutton'),
                    countryDescriptionPhrase: PhrasesService.shared.getPhrase('donation_countrydescription'),
                    countryUrlPhrase: PhrasesService.shared.getPhrase('donation_countrydescriptionurl'),
                    setNOfStudentsUrlTitle: PhrasesService.shared.getPhrase('donation_setnofstudentsurltitle'),
                    onetimeGiveInternetButtonPhrase: PhrasesService.shared.getPhrase('donation_onetimegiveinternetbuttontitle'),
                    donateOnetimeTitlePhrase: PhrasesService.shared.getPhrase('donation_donateonetimetitle'),
                    onetimeTabTitlePhrase: PhrasesService.shared.getPhrase('donation_onetimetabtitle'),
                    donateCryptoUrlPhrase: PhrasesService.shared.getPhrase('donation_donatecryptourl'),
                    donateCryptoUrlTitlePhrase: PhrasesService.shared.getPhrase('donation_donatecryptourltitle'),
                    donateTermsAndPrivacy: PhrasesService.shared.getPhrase('donation_termsandprivacy'),
                    minAmountErrorMessagePhrase: PhrasesService.shared.getPhrase('donation_minamounterrormessage'),
                    monthlyCombinedProductHintPhrase: PhrasesService.shared.getPhrase('donation_monthlycombinedproducthintphrase'),
                    oneTimeCombinedProductHintPhrase: PhrasesService.shared.getPhrase('donation_onetimecombinedproducthintphrase'),
                },
                sendingData: false,
                monthlyTabVisible: true,
                isProjectSelectedByUser: false,
                showMessage: false,
                message: null,
                messageClass: '',
                messageIconName: '',
                showSignInButton: false,
                productTypes: {
                    monthly: 1,
                    onetime: 2,
                    combined: 3
                },
            }
        },
        methods: {
            showAnyAmount() {
                var _this = this;
                _this.showAnyAmountOption = true;
                var anyAmountProduct = _this.products.filter(p => !p.Checked && p.PaymentTerm == 1 && p.AmountType == 1);
                anyAmountProduct[0].Checked = true;
                _this.unCheckAllProductsExeptChecked(anyAmountProduct[0]);
            },
            closeAnyAmountPopup() {
                var _this = this;
                _this.showAnyAmountOption = false;
                var monthlyAnyAmountProduct = _this.products.filter(p => p.PaymentTerm == 1 && p.AmountType == 1)[0];
                monthlyAnyAmountProduct.Checked = false;
                _this.checkAtLeastOneMonthlyProduct(monthlyAnyAmountProduct);
            },
            getMonthlyDonationProducts() {
                var _this = this;
                return _this.products.filter(p => p.PaymentTerm == 1);;
            },
            getOneTimeDonationProducts() {
                var _this = this;
                return _this.products.filter(p => p.PaymentTerm == 2);
            },
            setActiveTab(tab, hash) {
                var _this = this;
                _this.activeTab = tab;
                window.history.replaceState('', '', '#' + hash);
            },
            getGiveInternetButtonTitle() {
                var _this = this;
                var html = `<span class="\donation-box__total-payment\">${_this.formatAmount(_this.totalAmount)}</span>`;
                if (_this.activeTab == 0) {
                    return _this.replaceAmountStr(_this.phrases.monthlyGiveInternetButtonPhrase, html);
                }

                if (_this.activeTab == 1) {
                    return _this.replaceAmountStr(_this.phrases.bundleGiveInternetButtonPhrase, html);
                }

                if (_this.activeTab == 2) {
                    return _this.replaceAmountStr(_this.phrases.onetimeGiveInternetButtonPhrase, html);
                }
            },
            getDonatingAmountTitle() {
                var _this = this;

                if (_this.activeTab == 0)
                    return _this.replaceAmountStr(_this.phrases.donateMonthlyTitlePhrase, _this.formatAmount(_this.totalAmount));

                if (_this.activeTab == 1)
                    return _this.replaceAmountStr(_this.phrases.donateBundleTitlePhrase, _this.formatAmount(_this.totalAmount));

                if (_this.activeTab == 2)
                    return _this.replaceAmountStr(_this.phrases.donateOnetimeTitlePhrase, _this.formatAmount(_this.totalAmount));
            },
            getTotalDonationTitle() {
                var _this = this;
                if (_this.activeTab == 0)
                    return _this.replaceAmountStr(_this.phrases.totalAmountMonthlyPhrase, _this.totalDonationAmount);

                if (_this.activeTab == 1)
                    return _this.replaceAmountStr(_this.phrases.totalAmountBundlePhrase, _this.totalDonationAmount);

                if (_this.activeTab == 2)
                    return _this.replaceAmountStr(_this.phrases.totalAmountBundlePhrase, _this.totalDonationAmount);
            },
            hideAnyAmountOption() {
                var _this = this;
                _this.showAnyAmountOption = false;
            },
            replaceAmountStr(phrase, amount) {
                var replacedPhrase = '';
                if (phrase)
                    replacedPhrase = phrase.replace('[amount]', amount);

                return replacedPhrase;
            },
            formatAmount(amount) {
                return amount.toFixed(2);
            },
            checkAtLeastOneMonthlyProduct(product) {
                var _this = this;
                _this.products.filter(p => p != product && p.PaymentTerm == 1 && p.AmountType == 0);
                _this.products[0].Checked = true;
            },
            unCheckAllProductsExeptChecked(product) {
                var _this = this;
                _this.productQuantity = 1;
                _this.products.filter(p => p != product && p.PaymentTerm == product.PaymentTerm).forEach(p => p.Checked = false);
            },
            getCurrentStepIndex(stepId) {
                var _this = this;
                var index = _this.state.steps.map(function (e) {
                    return e.id;
                }).indexOf(stepId);
                return index;
            },
            showStep(stepId) {
                var _this = this;

                return !!_this.state.currentStep
                    && _this.state.currentStep.id == stepId
            },
            goNext() {
                var _this = this;
                if (!_this.state.currentStep)
                    return;
                var index = _this.getCurrentStepIndex(_this.state.currentStep.id);
                _this.state.currentStep = _this.state.steps[index + 1];
                _this.scrollToTop();
            },
            goBack() {
                var _this = this;
                _this.resetMessage();
                var index = _this.getCurrentStepIndex(_this.state.currentStep.id);
                _this.state.currentStep = _this.state.steps[index - 1];
            },
            validateEmail(email, isRequired) {
                var _this = this;
                var isEmailValid = false;
                email.error = null;
                if (!email.value && !isRequired) {
                    return true;
                }

                if (!email.value) {
                    email.error = "Email is required";
                    return isEmailValid;
                }

                isEmailValid = (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(email.value);
                if (!isEmailValid) {
                    email.error = _this.phrases.emailNotValid;
                    return;
                }

                return isEmailValid;
            },
            validateFullname(fullname) {
                var isValid = false;
                fullname.error = null
                if (!fullname.value) {
                    fullname.error = "Name is required";
                    return isValid;
                }

                return true;
            },
            getSelectedProductsByActiveTab() {
                var _this = this;
                //monthly;
                if (_this.activeTab == 0) {
                    var checkedMonthlyProducts = _this.products.filter(p => p.Checked && p.PaymentTerm == 1);
                    var combinedProduct = checkedMonthlyProducts
                        .filter(p => p.Checked && p.ProductType == _this.productTypes.combined)[0];
                    if (combinedProduct) {
                        var filteredProducts = _this.products
                            .filter(p => p != combinedProduct && p.PaymentTerm == combinedProduct.PaymentTerm && p.AmountType == 0);
                        return filteredProducts;
                    }

                    return checkedMonthlyProducts;
                }

                //onetime;
                if (_this.activeTab == 2) {
                    var checkedOnetimeProducts = _this.products.filter(p => p.Checked && p.PaymentTerm == 2);
                    var combinedProduct = checkedOnetimeProducts
                        .filter(p => p.Checked && p.ProductType == _this.productTypes.combined)[0];
                    if (combinedProduct) {
                        var filteredProducts = _this.products
                            .filter(p => p != combinedProduct && p.PaymentTerm == combinedProduct.PaymentTerm && p.AmountType == 0);
                        return filteredProducts;

                    }
                    return checkedOnetimeProducts;
                }
            },
            selectProgram() {
                var _this = this;
                _this.isProjectSelectedByUser = true;
                _this.projectId = _this.checkedProjectId;
                $.fancybox.close();
            },
            closeProgramPopUp() {
                var _this = this;
                _this.checkedProjectId = _this.projectId;
            },
            getPostData(captchaToken) {
                var _this = this;
                var selectedProducts = _this.getSelectedProductsByActiveTab();
                if (selectedProducts.length == 0)
                    return;

                if (!_this.validateEmail(_this.marketingEmail, false))
                    return;

                var paymentTerm = selectedProducts[0].PaymentTerm;
                var products = [];

                selectedProducts.forEach(function (product) {
                    products.push({
                        ProductId: product.ProductId,
                        ItemQuantity: parseInt(product.Quantity),
                        ItemAmount: parseInt(product.Amount)
                    });
                });

                var data = {
                    ProjectId: _this.checkedProjectId,
                    AdministrativeTip: _this.administrativeTip,
                    PaymentTerm: paymentTerm,
                    MarketingEmail: _this.marketingEmail.value,
                    IsAnonymous: _this.isAnonymous,
                    Products: products,
                    captchaToken: captchaToken
                };
                return data;
            },
            resetMessage() {
                var _this = this;
                _this.showMessage = false;
                _this.message = null;
                _this.messageClass = null;
                _this.messageIconName = null;
                _this.showSignInButton = false;
            },
            getProgramDescription() {
                var _this = this;
                if (_this.isProjectSelectedByUser) {
                    var project = _this.projects.find(p => p.ProjectId == _this.checkedProjectId);
                    if (project) {
                        var projectTitle = project.IsGeneralFund ? project.Title : project.CountryTitle;
                        return _this.phrases.countryDescriptionPhrase.replace('[country]', projectTitle);
                    }
                } else {
                    return _this.phrases.specificCountryDescriptionPhrase;
                }
            },
            getProgramUrlTitle() {
                var _this = this;
                if (_this.isProjectSelectedByUser)
                    return _this.phrases.countryUrlPhrase;

                return _this.phrases.specificCountryUrlPhrase;
            },
            getTabByName(name) {
                switch (name) {
                    case 'monthly':
                        return 0;
                        break;
                    //case 'bundle':
                    //    return 1
                    //    break;
                    case 'onetime':
                        return 2
                        break;
                    default:
                        return 0;
                }
            },
            isHashValid(hash) {
                switch (hash) {
                    case 'monthly':
                        return true;
                        break;
                    //case 'bundle':
                    //    return true;
                    //    break;
                    case 'onetime':
                        return true
                        break;
                    default:
                        return false;
                }
            },
            getActiveTabName() {
                var _this = this;
                var activeTab = _this.monthlyTabVisible
                    ? parseInt(_this.activeTab)
                    : 2;
                switch (activeTab) {
                    case 0:
                        return 'monthly';
                        break;
                    case 1:
                        return 'bundle';
                        break;
                    case 2:
                        return 'onetime';
                };
            },
            triggerElementClick(element) {
                if (element)
                    element.click();
            },
            processUrlHash() {
                var _this = this;
                var hash = '';
                if (window.location.hash.length > 1) {

                    var windowLocationHash = window.location.hash.substring(1);
                    if (!_this.isHashValid(windowLocationHash)) {
                        window.history.replaceState('', '', window.location.pathname);
                        window.location.reload();
                        return;
                    }
                    hash = !_this.monthlyTabVisible && windowLocationHash == 'monthly'
                        ? 'onetime'
                        : windowLocationHash;

                    _this.setActiveTab(_this.getTabByName(hash), hash);
                    return;
                }
                hash = _this.getActiveTabName();
                _this.setActiveTab(_this.getTabByName(hash), hash);
            },
            onHashChangeEvent() {
                var _this = this;
                $(window).on('hashchange', function () {
                    _this.processUrlHash();
                });
            },
            initSlider() {
                var _this = this;
                var allocationrange = _this.$refs.allocationrange;
                noUiSlider.create(allocationrange, {
                    connect: [true, false],
                    start: [_this.administrativeTip],
                    step: 5,
                    range: {
                        'min': [0],
                        'max': [100]
                    }
                });
                allocationrange.noUiSlider.on('update', function (values, handle) {
                    _this.administrativeTip = parseFloat(values[handle]);
                });
            },
            showErrorMessage(message) {
                var _this = this;
                _this.showMessage = true;
                _this.message = message;
            },
            addCombinedProductsToProducts() {
                var _this = this;
                var productsList = [];
                var monthlyProducts = _this.filterProducts(1, 0);
                var anyAmountMonthlyProduct = _this.filterProducts(1, 1);
                var oneTimeProducts = _this.filterProducts(2, 0);
                var anyAmountOneTimeProduct = _this.filterProducts(2, 1);

                var combinedMonthlyProduct = _this.createCombinedProduct(monthlyProducts, 1, _this.productTypes.combined);
                var combinedOneTimeProduct = _this.createCombinedProduct(oneTimeProducts, 2, _this.productTypes.combined);

                _this.uncheckMultipleSelected(monthlyProducts);
                _this.uncheckMultipleSelected(oneTimeProducts);

                productsList.push(...monthlyProducts);
                productsList.push(combinedMonthlyProduct);
                if (anyAmountMonthlyProduct[0]) {
                    productsList.push(anyAmountMonthlyProduct[0]);
                }

                productsList.push(...oneTimeProducts);
                productsList.push(combinedOneTimeProduct);
                if (anyAmountOneTimeProduct[0]) {
                    productsList.push(anyAmountOneTimeProduct[0]);
                }

                _this.products = productsList;
            },
            filterProducts(paymentTerm, amountType) {
                return this.products.filter(p => p.PaymentTerm === paymentTerm && p.AmountType === amountType);
            },
            uncheckMultipleSelected(products) {
                var _this = this;
                var checkedProducts = products.filter(p => p.Checked);
                if (checkedProducts.length > 1) {
                    checkedProducts.forEach(product => {
                        product.Checked = false;
                        _this.productQuantity = parseInt(product.Quantity);
                    });
                }
            },
            createCombinedProduct(products, paymentTerm, productType) {
                return {
                    Amount: products[0].Amount + products[1].Amount,
                    Title: `${products[0].Title} + ${products[1].Title}`,
                    Checked: products.filter(p => p.Checked).length > 1,
                    AmountType: 0,
                    PaymentTerm: paymentTerm,
                    Quantity: this.productQuantity,
                    ProductType: productType
                };
            },
            plus() {
                var _this = this;
                _this.productQuantity = parseInt(_this.productQuantity) + 1;
            },
            minus() {
                var _this = this;
                if (_this.productQuantity == 1) {
                    return;
                }
                _this.productQuantity = parseInt(_this.productQuantity) - 1;
            },
            isNumber(event) {
                if (event.key == '.') {
                    event.preventDefault();
                }
                var keyCode = (event.which) ? event.which : event.keyCode;
                if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
                    event.preventDefault();
                    _this.showAnyAmountError = true;
                } else {
                    return true;
                }
            },
            checkQuantity(product) {
                var _this = this;
                var value = parseInt(_this.productQuantity);

                if (value == 0 || !value) {
                }
                _this.productQuantity = Math.min(9999, Math.max(1, _this.productQuantity));
            },
            checkQuantityInput() {
                var _this = this;
                var value = parseInt(_this.productQuantity);
                if (!value)
                    return;

                _this.checkQuantity();
            },
            async redirectToSignIn() {
                var _this = this;
                var selectedProducts = _this.getSelectedProductsByActiveTab();
                var selectedDonationProducts = [];

                selectedProducts.forEach(function (product) {
                    selectedDonationProducts.push({
                        ProductId: product.ProductId,
                        ItemQuantity: parseInt(product.Quantity),
                        ItemAmount: parseInt(product.Amount)
                    });
                });

                var data = {
                    projectId: _this.checkedProjectId,
                    administrativeTip: _this.administrativeTip,
                    activeTab: _this.activeTab,
                    showAnyAmountOption: _this.showAnyAmountOption,
                    donationProducts: selectedDonationProducts,
                    paymentTerm: selectedProducts[0].PaymentTerm
                };

                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'donation/StoreDonationDataToCookie', data)
                    .then((result) => {
                        var queryParams = this.isProjectSelectedByUser ? '?projectId=' + this.checkedProjectId : '';
                        window.location.href = this.signInUrl + '?ReturnUrl=' + this.donateUrl + queryParams;
                    })
                    .catch((error) => {
                        _this.sendingData = false;
                        _this.showErrorMessage(error.data.message);
                    });
            },
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            resetOneTimeAnyAmount(product) {
                var _this = this;
                if (_this.activeTab == 0) {
                    return;
                }

                if (product.AmountType == 1
                    && product.PaymentTerm == 2) {
                    return;
                }
                _this.products.filter(p => p.AmountType == 1 && p.PaymentTerm == 2).forEach(p => p.Amount = '');
            },
            async donate() {
                var _this = this;
                if (_this.sendingData) return;

                _this.sendingData = true;

                var captchaToken = await window._executeRecaptcha();

                _this.resetMessage();
                var data = _this.getPostData(captchaToken);
                if (!data) {
                    _this.sendingData = false;
                    return;
                }

                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'donation/createdonation', data)
                    .then((result) => {
                        if (result.success) {
                            window.location.href = _this.checkoutUrl + '?id=' + result.data.id + '&' + 'publicId=' + result.data.publicId;
                        }
                        _this.sendingData = false;
                    })
                    .catch((error) => {
                        _this.sendingData = false;
                        _this.showErrorMessage(error.data.message);
                    });
            },
            async createAnonymousUser() {
                var _this = this;
                if (_this.sendingData) return;
                _this.resetMessage();
                var isEmailValid = _this.validateEmail(_this.email, true);
                var isFullNameValid = _this.validateFullname(_this.fullname)
                if (!isEmailValid || !isFullNameValid) {
                    return;
                }
                var captchaToken = await window._executeRecaptcha();
                var data = {
                    fullname: _this.fullname.value,
                    email: _this.email.value,
                    captchaToken: captchaToken
                };
                _this.sendingData = true;
                ApiService.shared._makeHttpDataPostRequest(_this.identityBaseUrl, 'user/createAnonymousUser', data)
                    .then((result) => {
                        _this.sendingData = false;
                        if (result.data && result.data.userAlreadyExist) {
                            _this.showSignInButton = true;
                            _this.showErrorMessage(result.message);
                            return;
                        }

                        if (result.succeeded) {
                            _this.donate();
                        } else {
                            _this.showErrorMessage(result.message);
                        }
                    })
                    .catch((error) => {
                        _this.sendingData = false;
                        _this.showErrorMessage(error.data.message);
                    });
            }
        },
        mounted() {
            var _this = this;
            _this.state.currentStep = _this.state.steps[0];
            _this.marketingEmail.value = _this.currentUserEmail;
            _this.administrativeTip = parseInt(_this.allocationDefaultPercent);
            _this.monthlyTabVisible = !_this.hasAuthorizedUserFullAccess || !_this.isUserStatusActive;

            if (_this.showUserInfoStep) {
                _this.goNext();
            }

            _this.checkedProjectId = _this.projectId;
            _this.processUrlHash();
            _this.onHashChangeEvent();
            setTimeout(function () {
                _this.initSlider();
            })

            _this.addCombinedProductsToProducts();
        },
        computed: {
            totalAmount() {
                var _this = this;
                var totalAmount = _this.totalDonationAmount + (_this.totalDonationAmount * _this.administrativeTip / 100);
                return totalAmount;
            },
            totalDonationAmount() {
                var _this = this;
                var selectedProducts = _this.getSelectedProductsByActiveTab();
                var donationProductTotal = 0;
                for (var i = 0; i < selectedProducts.length; i++) {
                    donationProductTotal += selectedProducts[i].Quantity * selectedProducts[i].Amount;
                }
                return donationProductTotal;
            }
        }
    ,
template: `
    <div class="donation-box">
        <!--Step 10-->
        <div class="donation-box__content" v-show="showStep(10)">
            <div class="donation-tabs__head nav nav-tabs" id="donation-tabs" role="tablist"
                 v-bind:class="{'donation-tabs__head--hiddenonetime' : !monthlyTabVisible}">
                <a v-if="monthlyTabVisible"
                   href="#monthly"
                   ref="monthly"
                   role="tab"
                   class="donation-tabs__item nav-item "
                   v-bind:class="{'active' : activeTab == 0}"
                   id="donationMonthly-link"
                   data-toggle="tab"
                   aria-controls="donationMonthly"
                   @click.prevent="setActiveTab(0, 'monthly')">
                    {{phrases.monthlyTabTitlePhrase}}
                </a>
                <a href="#onetime"
                   ref="onetime"
                   role="tab"
                   class="donation-tabs__item nav-item"
                   v-bind:class="{'active' : activeTab == 2}"
                   id="donationOnetime-link"
                   data-toggle="tab"
                   aria-controls="donationOnetime"
                   @click.prevent="setActiveTab(2, 'onetime')">
                    {{phrases.onetimeTabTitlePhrase}}
                </a>
            </div>
            <div class="donation-tabs__body tab-content" id="donation-tabs-content">
                <!--MONTHLY TAB-->
                <div class="donation-tabs__content tab-pane fade"
                     id="donationMonthly"
                     aria-labelledby="donationMonthly-link"
                     v-bind:class="{'show active' : activeTab == 0}"
                     v-if="activeTab == 0">

                    <!-- ANIMATION -->
                    <donation-animation v-if="showLaptopStundetsIcon"></donation-animation>
                    <!-- MONTHLY DONATION OPTIONS -->
                    <div class="donation-options">
                        <donation-product v-for="product in getMonthlyDonationProducts()"
                                          :product="product"
                                          :show-any-amount-option="showAnyAmountOption"
                                          :minAmountErrorMessagePhrase="phrases.minAmountErrorMessagePhrase"
                                          :product-quantity="productQuantity"
                                          :monthlyCombinedProductHintPhrase="phrases.monthlyCombinedProductHintPhrase"
                                          @hideAnyAmountOption="hideAnyAmountOption()"
                                          @checkAtLeastOneMonthlyProduct="checkAtLeastOneMonthlyProduct($event)"
                                          @unCheckAllProductsExeptChecked="unCheckAllProductsExeptChecked($event)"
                                          @resetOneTimeAnyAmount="resetOneTimeAnyAmount($event)">
                        </donation-product>
                    </div>

                    <!-- CHOOSE NUMBER OF STUDENTS -->
                    <div class="donation-options__action" v-if="!showAnyAmountOption">
                        <div class="donation-options__calculator">
                            <p class="donation-options__calculator-title">Choose number of students</p>
                            <div class="calculator-card__calculator">
                                <a class="calculator-card__calculator-action js-calculator-minus"
                                   @click.prevent="minus">
                                    <svg-icon class="calculator-card__calculator-icon calculator-card__calculator-icon--minus" icon="symbol-minus"></svg-icon>
                                </a>
                                <input type="text" class="calculator-card__calculator-amount"
                                       maxlength="4"
                                       v-model="productQuantity"
                                       @input="checkQuantityInput()"
                                       @keypress="isNumber($event)"
                                       @blur="checkQuantity()">
                                <a class="calculator-card__calculator-action js-calculator-plus"
                                   @click.prevent="plus">
                                    <svg-icon class="calculator-card__calculator-icon calculator-card__calculator-icon--plus" icon="symbol-plus"></svg-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!--TOTAL DONATION-->
                    <div class="donation-total">
                        <div class="donation-total__sum" v-html="getTotalDonationTitle()"></div>
                        <div class="donation-total__action" v-show="!showAnyAmountOption">
                            <p>
                                {{phrases.anyAmountTextPhrase}}<br />
                                <a @click.prevent="showAnyAmount()" href="" class="button-link button-link--default js-open-any-amount">{{phrases.anyAmountUrlTitlePhrase}}</a>
                            </p>
                        </div>
                        <div class="donation-total__action" v-show="showAnyAmountOption">
                            <p>
                                <a href="" @click.prevent="closeAnyAmountPopup()" class="button-link button-link--default js-close-any-amount">{{phrases.setNOfStudentsUrlTitle}}</a>
                            </p>
                        </div>
                    </div>
                </div>

                <!--ONETIME TAB-->
                <div class="donation-tabs__content tab-pane fade"
                     id="donationOnetime"
                     aria-labelledby="donationOnetime-link"
                     v-bind:class="{'show active' : activeTab == 2}">
                    <!-- START ANIMATION -->
                    <donation-animation v-if="showLaptopStundetsIcon"></donation-animation>

                    <!--<div class="donation-onetime" v-html="phrases.bundleDescriptionPhrase">
                    </div>-->
                    <!-- END ANIMATION -->
                    <div class="donation-options">
                        <donation-product v-for="product in getOneTimeDonationProducts()"
                                          :product="product"
                                          :product-quantity="productQuantity"
                                          :oneTimeCombinedProductHintPhrase="phrases.oneTimeCombinedProductHintPhrase"
                                          @checkAtLeastOneMonthlyProduct="checkAtLeastOneMonthlyProduct($event)"
                                          @unCheckAllProductsExeptChecked="unCheckAllProductsExeptChecked($event)"
                                          @resetOneTimeAnyAmount="resetOneTimeAnyAmount($event)">
                        </donation-product>
                    </div>
                </div>
            </div>
            <div class="donation-drag">
                <h4 class="donation-drag__title">
                    {{phrases.allocationTitlePhrase}} <span>+{{administrativeTip}}%</span>
                    <div class="donation-options__single-info-wrap">
                        <svg-icon class="donation-options__single-info-icon" icon="symbol-info"></svg-icon>
                        <div class="donation-options__single-info">
                            <div class="donation-options__single-info-clipboard"></div>
                            <p>{{phrases.allocationHintPhrase}}</p>
                        </div>
                    </div>
                </h4>
                <div class="donation-drag__slider-wrap">
                    <div ref="startValue" class="donation-drag__slider-value donation-drag__slider-value--start" id="startValue"><span ref="span">0%</span></div>
                    <div ref="allocationrange" class="donation-drag__slider" id="allocationrange"></div>
                    <div ref="endValue" class="donation-drag__slider-value donation-drag__slider-value--end" id="endValue"><span ref="span">100%</span></div>
                </div>
            </div>
            <div class="donation-actions">
                <a href="" @click.prevent="goNext(20) " class="button-action button-action--primary button-action--medium"
                   v-html="getGiveInternetButtonTitle()"></a>
                <donation-credit-card-info :show-pay-pal-card="activeTab != 0"></donation-credit-card-info>
                <p class="donation-actions__additional">
                    {{getProgramDescription()}}
                    <a href="" data-fancybox data-src="#countriesList" data-modal="true" class="button-link button-link--default">{{getProgramUrlTitle()}}?</a>
                </p>
            </div>
            <donation-footer></donation-footer>
        </div>

        <!--Step 20-->
        <div class="donation-box__content" v-show="showStep(20)">
            <div class="donation-box__back">
                <a @click.prevent="goBack()" href="" class="button-link button-link--default">Back</a>
            </div>
            <div class="donation-pay">
                <div class="donation-pay__text donation-pay__text--bottombordered">
                    <p class="donation-pay__title">{{phrases.youAreDonating}}</p>
                    <p class="donation-pay__amount" v-html="getDonatingAmountTitle()">
                    </p>
                </div>
                <div class="form">
                    <div class="form__group" v-if="!hasAuthorizedUserFullAccess" v-bind:class="{'has-error' : !!fullname.error}">
                        <label for="" class="form__label">{{phrases.fullname}}</label>
                        <div class="form__content">
                            <input v-model="fullname.value" type="text" class="form__element form__element--input" value="{{fullname.value}}">
                        </div>
                        <p class="form__error-text">{{fullname.error}}</p>
                    </div>
                    <div class="form__group" v-if="!hasAuthorizedUserFullAccess" v-bind:class="{'has-error' : !!email.error}">
                        <label for="" class="form__label">{{phrases.email}}</label>
                        <div class="form__content">
                            <input v-model="email.value" type="text" class="form__element form__element--input" value="{{email.value}}">
                        </div>
                        <p class="form__error-text">{{email.error}}</p>
                    </div>
                    <div class="form__group" v-if="hasAuthorizedUserFullAccess" v-bind:class="{'has-error' : !!marketingEmail.error}">
                        <label for="" class="form__label">{{phrases.email}}</label>
                        <div class="form__content">
                            <input v-model="marketingEmail.value" type="text" class="form__element form__element--input" value="{{marketingEmail.value}}">
                        </div>
                        <p class="form__error-text">{{marketingEmail.error}}</p>
                    </div>
                    <div class="form__info">
                        <div class="form__info-icon-wrap">
                            <svg-icon class="form__info-icon" icon="symbol-info"></svg-icon>
                        </div>
                        <div class="form__info-text-wrap">
                            <p class="form__info-text" v-html="phrases.emailTextPhrase"></p>
                        </div>
                    </div>
                    <div class="form__options">
                        <div class="custom-checkbox">
                            <input v-model="isAnonymous" type="checkbox" class="custom-checkbox__input" id="pc1" name="pc1" value="{{isAnonymous}}">
                            <label for="pc1" class="custom-checkbox__label">
                                <span class="custom-checkbox__icon-wrap">
                                    <svg-icon class="custom-checkbox__icon" icon="symbol-checkbox-round"></svg-icon>
                                </span>
                                <span class="custom-checkbox__text">{{phrases.donateAnonymouslyPhrase}}</span>
                            </label>
                        </div>
                    </div>
                    <div class="form__action">
                        <a href="" @click.prevent=" isUserAuthorized && hasAuthorizedUserFullAccess ? donate() : createAnonymousUser()" class="button-action button-action--primary button-action--large"
                           v-bind:class="{'loading' : sendingData }">
                            <div class="spinner"></div>
                            {{phrases.donateButtonTitlePhrase}}
                        </a>
                    </div>
                    <div class="auth__message auth__message--error" v-if="showMessage">
                        <div class="auth__message-icon-wrap">
                            <svg-icon class="auth__message-icon" icon="symbol-times"></svg-icon>
                        </div>
                        <div class="auth__message-text-wrap">
                            <p class="auth__message-text">
                                {{message}}

                                <a href="" v-show="showSignInButton" @click.prevent="redirectToSignIn()" class="button-link button-link--primary">
                                    Sign in
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--legend-->
        <div class="donation-legend">
            <svg-icon class="donation-legend__icon" icon="symbol-lock"></svg-icon>
            <p class="donation-legend__text">{{phrases.legendTextPhrase}}</p>
        </div>
        <div class="donation-legend">
            <p class="donation-legend__text" v-html="phrases.donateTermsAndPrivacy"></p>
        </div>

        <!--custom modal-->
        <div class="custom-modal" id="countriesList" style="display: none;">
            <h2 class="custom-modal__title">{{phrases.selectProgramTitle}}</h2>
            <div class="countries-list">
                <div class="countries-list__single" v-for="project in projects">
                    <div class="custom-radio">
                        <input v-model="checkedProjectId" :value="project.ProjectId" type="radio" name="counties-list-option" :id="project.ProjectId" class="custom-radio__input">
                        <label :for="project.ProjectId" class="custom-radio__label">
                            <div class="custom-radio__icon-wrap">
                                <span class="custom-radio__icon"></span>
                            </div>
                            <div class="custom-radio__text">
                                <h6 class="custom-radio__title">{{project.Title}}</h6>
                                <p class="custom-radio__description">
                                    {{project.ShortDescription}}
                                </p>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="custom-modal__action">
                <a href="" @click.prevent="selectProgram()" class="button-action button-action--medium button-action--secondary active">{{phrases.selectProgramButton}}</a>
            </div>
            <a @click.prevent="closeProgramPopUp()" data-fancybox-close class="custom-modal__close">
                <svg-icon class="custom-modal__close-icon" icon="symbol-times"></svg-icon>
            </a>
        </div>
    </div>
`
});
Vue.component('donation-breakdown-calculator', {
        props: ['amountTitlePhrase', 'amountHintPhrase', 'receivesTitlePhrase', 'receivesHintPhrase', 'stripeFeePhrase', 'npoFeePhrase'],
        data: function () {
            return {
                amountPrefix: '$',
                amount: '$10',
                breakdownDataSettings: window.donationBreakdownData,
                formattedAmount: '',
                studentsReceives: 0,
                stripeCalculatedFee: 0,
                NPOCalculatedFee: 0
            };
        },
        methods: {
            plus() {
                var _this = this;
                var amount = _this.amountAsInt();
                _this.amount = amount + 1;
                _this.formatAmountAndCalculate();
            },
            minus() {
                var _this = this;
                var amount = _this.amountAsInt();
                _this.amount = amount - 1;
                _this.formatAmountAndCalculate();
            },
            formatAmountAndCalculate() {
                var _this = this;
                setTimeout(function () {
                    var amountAsInt = _this.amountAsInt();

                    _this.amount = _this.amountPrefix + amountAsInt;
                    _this.calculate();
                }, 0);
            },
            calculate() {
                var _this = this;
                var amount = _this.amountAsInt();
                _this.stripeCalculatedFee = amount * _this.breakdownDataSettings.StripeFeePercent / 100;
                _this.NPOCalculatedFee = amount * _this.breakdownDataSettings.NPOFeePercent / 100;
                _this.studentsReceives = (amount - _this.stripeCalculatedFee - _this.NPOCalculatedFee - _this.breakdownDataSettings.StripeFixedFee).toFixed(2);
            },
            amountAsInt() {
                var _this = this;
                var parsedAmount = parseInt(_this.amount.toString().replace(_this.amountPrefix, ''));
                if (parsedAmount > 9999) {
                    parsedAmount = 9999;
                }
                if (isNaN(parsedAmount) || parsedAmount == "" || parsedAmount == "undefined" || parsedAmount < 1) {
                    parsedAmount = 1;
                }
                return parsedAmount;
            }
        },
        mounted() {
            var _this = this;
            _this.formatAmountAndCalculate();
        }
    ,
template: `
    <div class="calculator-card__body calculator-card__body--grid">
        <div class="calculator-card__item calculator-card__calculator-wrap">
            <h6 class="calculator-card__item-title">{{amountTitlePhrase}}</h6>
            <div class="calculator-card__calculator">
                <a href="" class="calculator-card__calculator-action js-calculator-minus" @click.prevent="minus">
                    <svg-icon class="calculator-card__calculator-icon calculator-card__calculator-icon--minus" icon="symbol-minus"></svg-icon>
                </a>
                <div class="calculator-card__calculator-amount">
                    <input class="calculator-card__calculator-amount"
                           maxlength="5"
                           v-model="amount"
                           @keypress="formatAmountAndCalculate"
                           @input="formatAmountAndCalculate"
                           @blur="formatAmountAndCalculate" />
                </div>
                <a href="" class="calculator-card__calculator-action js-calculator-plus" @click.prevent="plus">
                    <svg-icon class="calculator-card__calculator-icon calculator-card__calculator-icon--plus" icon="symbol-plus"></svg-icon>
                </a>
            </div>
            <p class="calculator-card__narrator">{{amountHintPhrase}}</p>
        </div>
        <div class="calculator-card__item calculator-card__commission">
            <div class="calculator-card__commission-item">
                <span class="calculator-card__commission-amount">-$\{{stripeCalculatedFee.toFixed(3)}}</span>
                <p>
                    <img src="~/m/u/donation-breakdown/stripe.svg" alt=""> {{stripeFeePhrase}} ({{breakdownDataSettings.StripeFeePercent}}% + $\{{breakdownDataSettings.StripeFixedFee.toFixed(2)}})
                </p>
            </div>
            <div class="calculator-card__commission-item">
                <span class="calculator-card__commission-amount">-$\{{NPOCalculatedFee.toFixed(3)}}</span>
                <p>{{npoFeePhrase}} ({{breakdownDataSettings.NPOFeePercent}}%)</p>
            </div>
        </div>
        <div class="calculator-card__item calculator-card__results">
            <h6 class="calculator-card__item-title">{{receivesTitlePhrase}}</h6>
            <h5 class="calculator-card__real-amount">$\{{studentsReceives}}</h5>
            <p class="calculator-card__narrator">{{receivesHintPhrase}}</p>
        </div>
    </div>
`
});
Vue.component('donation-credit-card-info', {
        props: ["showPayPalCard"
          
        ],
        data: function () {
            return {}
        },
        methods: {},
        mounted() {
            var _this = this;
        },
        computed: {
           
        }
    ,
template: `
    <div class="donation-credit-cards">
        <a class="donation-credit-cards__item">
            <img class="donation-credit-cards__image" src="~/m/u/credit-cards/visa.png" alt="Visa" />
        </a>
        <a class="donation-credit-cards__item">
            <img class="donation-credit-cards__image" src="~/m/u/credit-cards/mastercard.png" alt="Mastercard" />
        </a>
        <a class="donation-credit-cards__item">
            <img class="donation-credit-cards__image" src="~/m/u/credit-cards/amex.png" alt="Amex" />
        </a>
        <a class="donation-credit-cards__item">
            <img class="donation-credit-cards__image" src="~/m/u/credit-cards/discover.png" alt="Discover" />
        </a>
        <a v-if="showPayPalCard" class="donation-credit-cards__item">
            <img class="donation-credit-cards__image" src="~/m/u/credit-cards/paypal.png" alt="Paypal" />
        </a>
        <a v-if="showPayPalCard" class="donation-credit-cards__item">
            <img class="donation-credit-cards__image" src="~/m/u/credit-cards/venmo.png" alt="Paypal" />
        </a>
        <a class="donation-credit-cards__item">
            <img class="donation-credit-cards__image" src="~/m/u/credit-cards/applePay.png" alt="applePay" />
        </a>
        <a class="donation-credit-cards__item">
            <img class="donation-credit-cards__image" src="~/m/u/credit-cards/gpay.png" alt="gpay" />
        </a>
    </div>
`
});
Vue.component('donation-footer', {
        props: [],
        data: function () {
            return {
                phrases: {
                    donateCryptoUrlPhrase: PhrasesService.shared.getPhrase('donation_donatecryptourl'),
                    donateCryptoUrlTitlePhrase: PhrasesService.shared.getPhrase('donation_donatecryptourltitle'),
                }
            }
        },
        methods: {},
        mounted() {},
        computed: {}
    ,
template: `
    <div class="donation-foot">
        <a :href="phrases.donateCryptoUrlPhrase" class="donation-foot__link" target="_blank">
            <span>{{phrases.donateCryptoUrlTitlePhrase}}  </span>
            <img src="~/m/u/crypto/endaoment.png" alt="" />
        </a>
    </div>
`
});
Vue.component('donation-product', {
        props: ['product', 'showAnyAmountOption', 'minAmountErrorMessagePhrase', 'productQuantity', 'monthlyCombinedProductHintPhrase', 'oneTimeCombinedProductHintPhrase'],
        data: function () {
            return {
                showAnyAmountError: false,
            };
        },
        methods: {
            checkProduct(product) {
                var _this = this;
                product.Checked = true;
                _this.productQuantity = 1;
                _this.product.Quantity = 1;
                _this.$emit('unCheckAllProductsExeptChecked', product);
                _this.$emit('resetOneTimeAnyAmount', product);
            },
            checkAnyAmount() {
                var _this = this;
                _this.showAnyAmountError = false;
                var value = parseInt(_this.product.Amount);
                if (value < _this.product.MinAmount) {
                    _this.showAnyAmountError = true;
                }

                if (!value) {
                    value = _this.product.MinAmount;
                }

                _this.product.Amount = Math.min(999999, Math.max(_this.product.MinAmount, _this.product.Amount));
            },
            checkAnyAmountInput() {
                var _this = this;
                _this.showAnyAmountError = false;
                var value = parseInt(_this.product.Amount);

                if (value <= 0) {
                    _this.checkAnyAmount();
                }
            },
            hideAnyAmountOption(product) {
                var _this = this;
                product.Checked = false;
                _this.$emit('hideAnyAmountOption')
                _this.$emit('checkAtLeastOneMonthlyProduct', product);
            },
            isNumber(event) {
                if (event.key == '.') {
                    event.preventDefault();
                }
                var keyCode = (event.which) ? event.which : event.keyCode;
                if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
                    event.preventDefault();
                    _this.showAnyAmountError = true;
                } else {
                    return true;
                }
            },
            getAmountErrorMessage() {
                var _this = this;
                return _this.minAmountErrorMessagePhrase.replace('[amount]', _this.product.MinAmount);
            },
            getProductHint(product) {
                var _this = this;
                if (product.PaymentTerm == 1 && product.ProductType == 3) {
                    return _this.monthlyCombinedProductHintPhrase;
                }

                if (product.PaymentTerm == 2 && product.ProductType == 3) {
                    return _this.oneTimeCombinedProductHintPhrase;
                }

                return product.Hint;
            },
            setOneTimeAnyAmountDefaultValue() {
                var _this = this;
                var product = _this.product;
                if (product.AmountType == 1
                    && product.PaymentTerm == 2
                    && product.Amount == 0) {
                    product.Amount = '';
                }
            },
        },
        mounted() {
            var _this = this;
            _this.setOneTimeAnyAmountDefaultValue();
        },
        computed: {
            productTotalAmount() {
                var _this = this;
                _this.product.Quantity = _this.product.PaymentTerm == 1 ? _this.productQuantity : 1;
                var productTotalAmount = _this.product.Checked ? _this.product.Quantity * _this.product.Amount : _this.product.Amount;
                return productTotalAmount;
            }
        }
    ,
template: `
    <div v-bind:class="{
          'donation-options__single--any-amount':
            (product.AmountType == 1 && product.PaymentTerm == 1) ||
            (product.AmountType == 1 && product.PaymentTerm == 2),
          'donation-options__single-wrap--last-child':
            product.ProductType == 3
        }">

        <div class="donation-options__single"
             v-bind:class="{'checked':product.Checked}"
             v-if="product.AmountType == 0"
             v-show="!showAnyAmountOption"
             @click.prevent="checkProduct(product)">
            <p class="donation-options__single-value">
                $\{{productTotalAmount}}
               <!-- <span v-if="product.PaymentTerm == 1">/mo</span>-->
            </p>
            <span class="donation-options__single-key">{{ product.Title }}</span>
            <div class="donation-options__single-info-wrap">
                <svg-icon class="donation-options__single-info-icon" icon="symbol-info"></svg-icon>
                <div class="donation-options__single-info">
                    <div class="donation-options__single-info-clipboard"></div>
                    <div v-html="getProductHint(product)"></div>
                </div>
            </div>
        </div>

        <div class="donation-options__any-amount"
             v-if="product.AmountType == 1 && showAnyAmountOption">
            <div class="donation-options__any-amount-content">
                <p>{{product.AmountPreffix}}</p>
                <div class="donation-options__any-amount-input">
                    <span>$</span>
                    <input type="text" maxlength="6"
                           v-model="product.Amount"
                           @keypress="isNumber($event)"
                           @blur="checkAnyAmount()"
                           @input="checkAnyAmountInput()">
                </div>
                <p class="donation-options__any-amount-hint error" v-if="showAnyAmountError">{{getAmountErrorMessage()}}</p>
            </div>
            <a href="" class="donation-options__any-amount-close js-close-any-amount"
               v-if="product.PaymentTerm == 1"
               @click.prevent="hideAnyAmountOption(product)">
                <!--v-if="product.PaymentTerm == 1"-->
                <svg-icon class="donation-options__any-amount-close-icon" icon="symbol-times"></svg-icon>
            </a>
        </div>

        <div class="donation-options__any-amount"
             v-if="product.AmountType == 1 && product.PaymentTerm == 2 && !showAnyAmountOption">
            <span class="donation-options__any-amount-label">Or Any Amount</span>
            <div class="donation-options__any-amount-field-wrap">
                <input type="text" class="donation-options__any-amount-field" maxlength="6"
                       v-bind:class="{'checked':product.Checked}"
                       v-model="product.Amount"
                       @keypress="isNumber($event)"
                       @blur="checkAnyAmount()"
                       @input="checkAnyAmountInput()"
                       @click="checkProduct(product)" />
                <span class="donation-options__any-amount-fixed-placeholder">$</span>
            </div>
            <p class="donation-options__any-amount-hint error" v-if="showAnyAmountError"> Minimum amount: 3 USD </p>
        </div>
    </div>
`
});
Vue.component('message', {
        props: ['message', 'messageClass', 'icon', 'showButton'],
        data: function () {
            return {
                messageClassName: null
            }
        },
        methods: {
            getMessageClass() {
                var _this = this;
                _this.messageClassName = "auth__message--" + _this.messageClass;
                return _this.messageClassName;
            },
            redirectToSignIn() {
                var _this = this;
                _this.$emit('redirectToSignIn');
            }
        },
        mounted() {
        },
        computed:{
        }
    ,
template: `
    <div class="auth__message"
          v-bind:class="getMessageClass()">
        <div class="auth__message-icon-wrap">
            <svg-icon class="auth__message-icon"
                      :icon="icon">
            </svg-icon>
        </div>
        <div class="auth__message-text-wrap">
            <p class="auth__message-text js-message-text">
                {{message}}

                <a href="" v-show="showButton" @click.prevent="redirectToSignIn()" class="button-link button-link--primary">
                    Sign in
                </a>
            </p>
        </div>
    </div>
`
});
Vue.component('profile-info', {
        props: [],
        data: function () {
            var userInfo = SettingsService.shared.data.userInfo;
            return {
                apiBaseUrl: SettingsService.shared.data.apiBaseUrl,
                userData: userInfo,
                userInfo: {
                    name: { value: userInfo.Name, error: null },
                    surname: { value: userInfo.Surname, error: null },
                    fullName: { value: userInfo.FullName, error: null },
                    email: { value: userInfo.Email, error: null },
                    isAnonymous: { value: userInfo.IsAnonymous, error: null }
                },
                passwordInfo: {
                    oldPassword: { value: null, error: null, type: 'password' },
                    newPassword: { value: null, error: null, type: 'password' },
                    repeatPassword: { value: null, error: null, type: 'password' }
                },
                showUpdateProfileSpinner: false,
                showChangePasswordSpinner: false,
                userEmail: null,
                phrases: {
                    deleteImageButton: PhrasesService.shared.getPhrase('profile_deleteimagebutton'),
                    updateProfileTitle: PhrasesService.shared.getPhrase('profile_updateprofiletitle'),
                    name: PhrasesService.shared.getPhrase('profile_name'),
                    surname: PhrasesService.shared.getPhrase('profile_surname'),
                    email: PhrasesService.shared.getPhrase('profile_email'),
                    anonymous: PhrasesService.shared.getPhrase('profile_anonymous'),
                    updateProfileButton: PhrasesService.shared.getPhrase('profile_updateprofilebutton'),
                    updatePasswordTitle: PhrasesService.shared.getPhrase('profile_updatepasswordtitle'),
                    oldPassword: PhrasesService.shared.getPhrase('profile_oldpassword'),
                    newPassword: PhrasesService.shared.getPhrase('profile_newpassword'),
                    repeatPassword: PhrasesService.shared.getPhrase('profile_repeatpassword'),
                    changePasswordButton: PhrasesService.shared.getPhrase('profile_changepasswordbutton'),
                    fieldRequired: PhrasesService.shared.getPhrase('profile_fieldrequired'),
                    passwordNotMatched: PhrasesService.shared.getPhrase('profile_passwordnotmatched'),
                    emailNotValid: PhrasesService.shared.getPhrase('profile_emailnotvaliderrormessage'),
                    imageUpdatedSuccessMessage: PhrasesService.shared.getPhrase('profile_imageuploadedsuccessmessage'),
                    imageDeletedSuccessMessage: PhrasesService.shared.getPhrase('profile_imagedeletedsuccessmessage'),
                    passwordChangedSuccessMessage: PhrasesService.shared.getPhrase('profile_passwordupdatedsuccessmessage'),
                    profileinfoupdatedsuccessmessage: PhrasesService.shared.getPhrase('profile_profileinfoupdatedsuccessmessage'),
                    minAmountErrorMessagePhrase: PhrasesService.shared.getPhrase('donation_minamounterrormessage'),
                },
            };
        },
        methods: {
            getFieldErrorClass(field) {
                return { 'has-error': field.error };
            },
            showHidePassword(field) {
                if (field.type == 'password') {
                    field.type = 'text';
                    return;
                }
                field.type = 'password';
            },
            clearAllValidation() {
                var _this = this;
                _this.userInfo.name.error = null;
                _this.userInfo.surname.error = null;
                _this.userInfo.email.error = null;
                _this.passwordInfo.oldPassword.error = null;
                _this.passwordInfo.newPassword.error = null;
                _this.passwordInfo.repeatPassword.error = null;
            },
            resetPasswordInfo() {
                var _this = this;
                _this.passwordInfo.oldPassword.value = null;
                _this.passwordInfo.newPassword.value = null;
                _this.passwordInfo.repeatPassword.value = null;
            },
            validatePasswordInfo() {
                var _this = this;
                var isValid = true;
                _this.clearAllValidation();
                var passInfo = _this.passwordInfo;
                if (_this.userData.PasswordSetByUser && !passInfo.oldPassword.value) {
                    _this.passwordInfo.oldPassword.error = _this.phrases.oldPassword + ' ' + _this.phrases.fieldRequired;
                    isValid = false;
                }

                if (!passInfo.newPassword.value) {
                    _this.passwordInfo.newPassword.error = _this.phrases.newPassword + ' ' + _this.phrases.fieldRequired;
                    isValid = false;
                }

                if (!passInfo.repeatPassword.value) {
                    _this.passwordInfo.repeatPassword.error = _this.phrases.repeatPassword + ' ' + _this.phrases.fieldRequired;
                    isValid = false;
                }

                if (passInfo.newPassword.value != passInfo.repeatPassword.value) {
                    _this.passwordInfo.repeatPassword.error = _this.phrases.passwordNotMatched;
                    isValid = false;
                }
                return isValid;
            },
            validateUserInfo() {
                var _this = this;
                var isValid = true;
                _this.clearAllValidation();
                if (!_this.userInfo.name.value) {
                    _this.userInfo.name.error = _this.phrases.name + ' ' + _this.phrases.fieldRequired;
                    isValid = false;
                }

                if (!_this.userInfo.surname.value) {
                    _this.userInfo.surname.error = _this.phrases.surname + ' ' + _this.phrases.fieldRequired;
                    isValid = false;
                }

                if (!_this.userInfo.email.value) {
                    _this.userInfo.email.error = _this.phrases.email + ' ' + _this.phrases.fieldRequired;
                    isValid = false;
                }

                if (_this.userInfo.email.value) {
                    var isEmailValid = (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(_this.userInfo.email.value);
                    if (!isEmailValid) {
                        _this.userInfo.email.error = _this.phrases.emailNotValid;
                        isValid = false;
                    }
                }

                return isValid;
            },
            async changePassword() {
                var _this = this;

                _this.showChangePasswordSpinner = true;

                var captchaToken = await window._executeRecaptcha();

                var isValid = _this.validatePasswordInfo();
                if (!isValid) {
                    _this.showChangePasswordSpinner = false;
                    return;
                }
                var data = {
                    oldPassword: _this.passwordInfo.oldPassword.value,
                    newPassword: _this.passwordInfo.newPassword.value,
                    repeatPassword: _this.passwordInfo.repeatPassword.value,
                    captchaToken: captchaToken
                }

                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'profile/changePassword', data)
                    .then((result) => {
                        if (result.success) {
                            _this.showChangePasswordSpinner = false;
                            _this.userData.PasswordSetByUser = true;
                            _this.resetPasswordInfo();
                            AlertService.shared.showSuccess(_this.phrases.passwordChangedSuccessMessage);
                        }
                    })
                    .catch((error) => {
                        _this.showChangePasswordSpinner = false;
                        AlertService.shared.showError(error.data.message)
                    });

                _this.showChangePasswordSpinner = false;
            },
            async updateUserInfo() {
                var _this = this;
                _this.showUpdateProfileSpinner = true;

                var captchaToken = await window._executeRecaptcha();

                var isValid = _this.validateUserInfo();
                if (!isValid) {
                    _this.showUpdateProfileSpinner = false;
                    return;
                }

                var data = {
                    Name: _this.userInfo.name.value,
                    Surname: _this.userInfo.surname.value,
                    Email: _this.userInfo.email.value,
                    IsAnonymous: _this.userInfo.isAnonymous.value,
                    captchaToken: captchaToken
                };
                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'profile/updateProfile', data)
                    .then((result) => {
                        _this.showUpdateProfileSpinner = false;
                        if (result.success) {
                            _this.userInfo.name.value = result.data.name;
                            _this.userInfo.surname.value = result.data.surname;
                            _this.userInfo.fullName.value = result.data.fullname;
                            _this.userInfo.email.value = result.data.email;
                            AlertService.shared.showSuccess(_this.phrases.profileinfoupdatedsuccessmessage);
                        } else {
                            AlertService.shared.showError(result)
                        }
                    })
                    .catch((error) => {
                        _this.showUpdateProfileSpinner = false;
                        AlertService.shared.showError(error.data.message)
                    });

            },
            async deleteImage() {
                var _this = this;

                if (!confirm("Do you want to delete your photo?")) {
                    return;
                }

                var captchaToken = await window._executeRecaptcha();

                var data = {
                    captchaToken: captchaToken
                }
                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'profile/DeleteProfilePhoto', data)
                    .then((result) => {
                        if (result.success) {
                            _this.userData.PhotoUrl = null;
                            _this.userData.HasPhoto = false;
                            AlertService.shared.showSuccess(_this.phrases.imageDeletedSuccessMessage);
                        }
                    })
                    .catch((error) => {
                        AlertService.shared.showError(error.data.message)
                    });

            },
            async uploadImage() {
                var _this = this;

                var captchaToken = await window._executeRecaptcha();
                var files = _this.$refs.file.files;
                var reader = new FileReader();
                reader.onload = function (e) {
                    _this.userData.PhotoUrl = e.target.result;
                };
                reader.readAsDataURL(files[0]);

                await ApiService.shared._makeHttpFilePostRequest('profile/uploadProfileImage', files[0], '', captchaToken)
                    .then((result) => {
                        if (result.success) {
                            _this.userData.HasPhoto = true;
                            _this.userData.PhotoUrl = result.data.photoUrl;
                            AlertService.shared.showSuccess(_this.phrases.imageUpdatedSuccessMessage);
                        } else {
                            AlertService.shared.showError(result);
                        }
                    })
                    .catch((error) => {
                        AlertService.shared.showError(error.data.message)
                    });
            }
        },
        mounted() {
            var _this = this;
            _this.userEmail = _this.userData.Email;
        }
    ,
template: `
    <div class="col-xl-8">
        <div class="profile-block">
            <div class="profile-block__head">
                <div class="profile-block__person">
                    <div class="supporters__item-avatar-wrap">
                        <div class="supporters__item-avatar" v-bind:style="{ 'background-image': 'url(' + userData.PhotoUrl + ')' }"></div>
                        <span>{{userData.NameInitial}}</span>
                        <div class="profile-block__upload">
                            <input ref="file" type="file" id="upload-photo" class="profile-block__upload-input" v-on:change="uploadImage()">
                            <label v-show="!userData.HasPhoto" for="upload-photo" class="profile-block__upload-label">
                                <svg-icon class="profile-block__upload-icon" icon="symbol-photo"></svg-icon>
                            </label>
                        </div>
                    </div>
                    <div class="profile-block__credentials">
                        <p class="profile-block__name">{{userInfo.fullName.value}}</p>
                        <a :href="'mailto:' + userEmail" class="profile-block__email" target='_blank'>{{userEmail}}</a>
                    </div>
                    <div v-show="userData.HasPhoto" class="profile-block__delete-image">
                        <a href="" @click.prevent="deleteImage()" class="button-link button-link--default">
                            <svg-icon icon="symbol-times"></svg-icon>{{phrases.deleteImageButton}}
                        </a>
                    </div>
                </div>
            </div>
            <div class="profile-block__body">
                <div class="profile-block__forms">
                    <div class="profile-block__row">
                        <div class="profile-block__column">
                            <h3 class="profile-block__title">{{phrases.updateProfileTitle}}</h3>
                            <div class="form">
                                <div class="form__group" v-bind:class="getFieldErrorClass(userInfo.name)">
                                    <label for="" class="form__label">{{phrases.name}}</label>
                                    <div class="form__content">
                                        <input type="text" class="form__element form__element--input" v-model="userInfo.name.value" :value="userInfo.name.value">
                                    </div>
                                    <p class="form__error-text">{{userInfo.name.error}}</p>
                                </div>
                                <div class="form__group" v-bind:class="getFieldErrorClass(userInfo.surname)">
                                    <label for="" class="form__label">{{phrases.surname}}</label>
                                    <div class="form__content">
                                        <input type="text" class="form__element form__element--input" v-model="userInfo.surname.value" :value="userInfo.surname.value">
                                    </div>
                                    <p class="form__error-text">{{userInfo.surname.error}}</p>
                                </div>
                                <div class="form__group" v-bind:class="getFieldErrorClass(userInfo.email)">
                                    <label for="" class="form__label">{{phrases.email}}</label>
                                    <div class="form__content">
                                        <input type="email" class="form__element form__element--input" v-model="userInfo.email.value" :value="userInfo.email.value">
                                    </div>
                                    <p class="form__error-text">{{userInfo.email.error}}</p>
                                </div>
                                <div class="form__group">
                                    <div class="custom-checkbox">
                                        <input v-model="userInfo.isAnonymous.value" type="checkbox" name="anonymousdonation" id="anonymousdonation" class="custom-checkbox__input" value="{{userInfo.isAnonymous.value}}" />
                                        <label for="anonymousdonation" class="custom-checkbox__label">
                                            <span class="custom-checkbox__icon-wrap">
                                                <svg class="custom-checkbox__icon">
                                                    <use xlink:href="~/m/i/icons.svg#symbol-checkbox-round"></use>
                                                </svg>
                                            </span>
                                            <span class="custom-checkbox__text">{{phrases.anonymous}}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form__action">
                                    <a href="" @click.prevent="updateUserInfo()" class="button-action button-action--medium button-action--primary" v-bind:class="{'loading': showUpdateProfileSpinner}">
                                        <div class="spinner"></div>
                                        {{phrases.updateProfileButton}}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="profile-block__column">
                            <h3 class="profile-block__title">{{phrases.updatePasswordTitle}}</h3>
                            <div class="form" v-bind:class="getFieldErrorClass(passwordInfo.oldPassword)">
                                <div class="form__group" v-show="userData.PasswordSetByUser" v-bind:class="getFieldErrorClass(passwordInfo.oldPassword)">
                                    <label for="" class="form__label">{{phrases.oldPassword}}</label>
                                    <div class="form__content">
                                        <input :type="passwordInfo.oldPassword.type" class="form__element form__element--input" :value="passwordInfo.oldPassword.value" v-model="passwordInfo.oldPassword.value">
                                        <a href="" @click.prevent="showHidePassword(passwordInfo.oldPassword)" class="form__show-password">
                                            <svg-icon class="form__show-password-icon" icon="symbol-witness"></svg-icon>
                                        </a>
                                    </div>
                                    <p class="form__error-text">{{passwordInfo.oldPassword.error}}</p>
                                </div>
                                <div class="form__group" v-bind:class="getFieldErrorClass(passwordInfo.newPassword)">
                                    <label for="" class="form__label">{{phrases.newPassword}}</label>
                                    <div class="form__content">
                                        <input :type="passwordInfo.newPassword.type" class="form__element form__element--input" :value="passwordInfo.newPassword.value" v-model="passwordInfo.newPassword.value">
                                        <a href="" @click.prevent="showHidePassword(passwordInfo.newPassword)" class="form__show-password">
                                            <svg-icon class="form__show-password-icon" icon="symbol-witness"></svg-icon>
                                        </a>
                                    </div>
                                    <p class="form__error-text">{{passwordInfo.newPassword.error}}</p>
                                </div>
                                <div class="form__group" v-bind:class="getFieldErrorClass(passwordInfo.repeatPassword)">
                                    <label for="" class="form__label">{{phrases.repeatPassword}}</label>
                                    <div class="form__content">
                                        <input :type="passwordInfo.repeatPassword.type" class="form__element form__element--input" :value="passwordInfo.repeatPassword.value" v-model="passwordInfo.repeatPassword.value">
                                        <a href="" @click.prevent="showHidePassword(passwordInfo.repeatPassword)" class="form__show-password">
                                            <svg-icon class="form__show-password-icon" icon="symbol-witness"></svg-icon>
                                        </a>
                                    </div>
                                    <p class="form__error-text">{{passwordInfo.repeatPassword.error}}</p>
                                </div>
                                <div class="form__action">
                                    <a href="" @click.prevent="changePassword()" class="button-action button-action--medium button-action--secondary" v-bind:class="{'loading': showChangePasswordSpinner}">
                                        <div class="spinner"></div>
                                        {{phrases.changePasswordButton}}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
`
});
Vue.component('profile-payments', {
        props: {
            isUserActiveDonor: Boolean,
            productQuantity: Number
        },
        data: function () {
            return {
                donationPayments: SettingsService.shared.data.donationPayments,
                donationInfo: SettingsService.shared.data.donationInfo,
                projects: SettingsService.shared.data.projects,
                donateUrl: SettingsService.shared.data.donateUrl,
                nextPayment: SettingsService.shared.data.nextPayment,
                apiBaseUrl: SettingsService.shared.data.apiBaseUrl,
                allProducts: [],
                showDonationInfo: false,
                showDonationBox: false,
                showDonationPayments: false,
                showLoadMoreButton: false,
                isAnyAmountPopupOpened: false,
                checkedProjectId: null,
                selectedProductAmountType: null,
                administrativeTip: null,
                sendingUpdateAmountData: false,
                isDonationUpdatedFromCancelation: false,
                productTypes: {
                    monthly: 1,
                    onetime: 2,
                    combined: 3
                },
                phrases: {
                    donationInfo: {
                        title: PhrasesService.shared.getPhrase('profile_donationinfotitle'),
                        description: PhrasesService.shared.getPhrase('profile_donationinfodescription'),
                        descriptionHint: PhrasesService.shared.getPhrase('profile_donationinfodescriptionhint'),
                        donatingProjectDescription: PhrasesService.shared.getPhrase('profile_donationinfodonatingprojectdescription'),
                        changeCountryButton: PhrasesService.shared.getPhrase('profile_donationinfochangecountrybutton'),
                        monthlyAmountTitle: PhrasesService.shared.getPhrase('profile_donationinfomonthlyamounttitle'),
                        updateAmountButton: PhrasesService.shared.getPhrase('profile_donationinfoupdateamountbutton'),
                        sponsoringproductdescription: PhrasesService.shared.getPhrase('profile_donationinfosponsoringproductdescription'),
                        noDonation: PhrasesService.shared.getPhrase('profile_nodonationdescription'),
                        donationButton: PhrasesService.shared.getPhrase('profile_donatebutton'),
                    },
                    donationBox: {
                        title: PhrasesService.shared.getPhrase('profile_donationboxtitle'),
                        backButton: PhrasesService.shared.getPhrase('profile_donationboxbackbutton'),
                        totalAmount: PhrasesService.shared.getPhrase('profile_donationboxtotalamount'),
                        anyAmountText: PhrasesService.shared.getPhrase('profile_donationboxanyamounttext'),
                        anyAmountUrlTitle: PhrasesService.shared.getPhrase('profile_donationboxanyamounturltitle'),
                        allocationTitle: PhrasesService.shared.getPhrase('profile_donationboxallocationtitle'),
                        allocationTitleHint: PhrasesService.shared.getPhrase('profile_donationboxallocationhint'),
                        updateAmountButton: PhrasesService.shared.getPhrase('profile_donationboxupdateamountbutton'),
                        specificCountryDescription: PhrasesService.shared.getPhrase('profile_donationboxspecificcountrydescription'),
                        specificCountryUrlTitle: PhrasesService.shared.getPhrase('profile_donationboxspecificcountryurl'),
                        countryDescriptionPhrase: PhrasesService.shared.getPhrase('profile_donationboxcountrydescription'),
                        countryUrlTitle: PhrasesService.shared.getPhrase('profile_donationboxcountrydescriptionurl'),
                        setNOfStudentsUrlTitle: PhrasesService.shared.getPhrase('profile_donationboxsetnofstudentsurltitle'),
                        minAmountErrorMessagePhrase: PhrasesService.shared.getPhrase('profile_donationminamounterrormessage'),
                    },
                    donationPayments: {
                        title: PhrasesService.shared.getPhrase('profile_paymentstitle'),
                        status: PhrasesService.shared.getPhrase('profile_paymentsstatus'),
                        date: PhrasesService.shared.getPhrase('profile_paymentsdate'),
                        amount: PhrasesService.shared.getPhrase('profile_paymentsamount'),
                        loadMoreButton: PhrasesService.shared.getPhrase('profile_paymentsloadmorebutton'),
                    },
                    donationProgram: {
                        title: PhrasesService.shared.getPhrase('profile_selectprogramtitle'),
                        button: PhrasesService.shared.getPhrase('profile_selectprogrambutton'),
                    },
                    donationProduct: {
                        monthlyCombinedProductHintPhrase: PhrasesService.shared.getPhrase('profile_monthlycombinedproducthintphrase'),
                    }
                },
                activeDonationProductQuantity: 1
            };
        },
        methods: {
            loadMore() {
                var _this = this;
                _this.donationPayments.filter(p => !p.Show)
                    .forEach(p => { p.Show = true; });
                _this.showLoadMoreButton = false;
            },
            openDonationBox() {
                var _this = this;
                _this.scrollToTop();
                if (!_this.showDonationBox) {
                    _this.showDonationInfo = false;
                    _this.showDonationBox = true;
                    setTimeout(function () {
                        _this.createSlider();
                        //$('.donation-options__single, .donation-options__any-amount').equalHeights();
                    }, 0);
                }

                if (_this.selectedProductAmountType == 1) {
                    _this.openAnyAmountPopup();
                } else {
                    _this.isAnyAmountPopupOpened = false;
                }
            },
            closeDonationBox() {
                var _this = this;
                _this.showDonationInfo = true;
                _this.showDonationBox = false;
                _this.donationInfo.Products = _this.cloneArray(_this.allProducts);
                _this.selectedProductAmountType = _this.getSelectedProductAmountType(_this.allProducts);
                _this.isAnyAmountPopupOpened = false;
                _this.isDonationUpdatedFromCancelation = false;
                _this.administrativeTip = _this.donationInfo.AdministrativeTip;
                _this.productQuantity = _this.activeDonationProductQuantity;
            },
            checkAtLeastOneProduct(product) {
                var _this = this;
                _this.donationInfo.Products[0].Checked = true;
                _this.donationInfo.Products[0].Quantity = 1;
                _this.productQuantity = 1;
            },
            openAnyAmountPopup() {
                var _this = this;
                _this.isAnyAmountPopupOpened = true;
                _this.uncheckAllCheckedProducts();
                _this.checkAnyAmountProduct();
            },
            closeAnyAmountPopup() {
                var _this = this;
                _this.isAnyAmountPopupOpened = false;
                var anyAmountProduct = _this.donationInfo.Products.filter(p => p.AmountType == 1)[0];
                anyAmountProduct.Checked = false;
                _this.checkAtLeastOneProduct(anyAmountProduct);
            },
            showLoadButton() {
                var _this = this;
                if (_this.donationPayments && _this.donationPayments.length > 7) {
                    return _this.showLoadMoreButton = true;
                }
                return _this.showLoadMoreButton = false;
            },
            getSelectedProducts() {
                var _this = this;
                var selectedProducts = _this.donationInfo.Products.filter(p => p.Checked);

                return selectedProducts;
            },
            uncheckAllCheckedProducts() {
                var _this = this;
                _this.donationInfo.Products
                    .filter(p => p.Checked)
                    .forEach(p => p.Checked = false);
            },
            checkAnyAmountProduct() {
                var _this = this;
                _this.donationInfo.Products
                    .filter(p => p.AmountType == 1)
                    .forEach(p => p.Checked = true);
            },
            cloneArray(products) {
                if (products)
                    return products.map(function (e) { return Object.assign({}, e); });
            },
            getSelectedProductAmountType(products) {
                if (products) {
                    var getSelectedProducts = products.filter(p => p.Checked);
                    return getSelectedProducts[0].AmountType;
                }
            },
            createSlider() {
                var _this = this;
                var allocationrange = _this.$refs.allocationrange;
                noUiSlider.create(allocationrange, {
                    connect: [true, false],
                    start: [_this.administrativeTip],
                    step: 5,
                    range: {
                        'min': [0],
                        'max': [100]
                    }
                });
                allocationrange.noUiSlider.on('update', function (values, handle) {
                    _this.administrativeTip = parseFloat(values[handle]);
                });
            },
            openProgramPopUp() {
                $.fancybox.open({ src: '#countriesList', modal: true });
            },
            selectProgram() {
                $.fancybox.close();
            },
            closeProgramPopUp() {
                var _this = this;
                _this.checkedProjectId = _this.donationInfo.ProjectId;
                $.fancybox.close();
            },
            replaceSponsoringProductDescriptionPhrase(productTitle, productQuantity) {
                var _this = this;
                var phrase = _this.phrases.donationInfo.sponsoringproductdescription;
                var replacedPhrase = phrase
                    .replace('[ProductTitle]', productTitle)
                    .replace('[ProductQuantity]', productQuantity);
                return replacedPhrase;
            },
            formatAmount(amount) {
                return amount.toFixed(2);
            },
            getTotalAmountPhrase() {
                var _this = this;
                var phrase = _this.phrases.donationBox.updateAmountButton;
                var formatedAmount = _this.formatAmount(_this.totalAmount);
                var html = `<span class="\donation-box__total-payment\">${formatedAmount}</span>`;
                var replacedPhraseHtml = phrase.replace('[totalAmount]', html);
                var spinnerHtml = '<div class="spinner"></div>';
                return spinnerHtml + replacedPhraseHtml;
            },
            getTotalDonationAmountPhrase() {
                var _this = this;
                var phrase = _this.phrases.donationBox.totalAmount;
                var replacedPhrase = phrase.replace('[totalDonationAmount]', _this.totalDonationAmount);
                return replacedPhrase;
            },
            getPostData(captchaToken) {
                var _this = this;
                var products = [];
                var selectedProducts = _this.getSelectedProducts();

                var combinedProduct = selectedProducts.find(p => p.ProductType == _this.productTypes.combined);
                if (combinedProduct) {
                    selectedProducts = _this.donationInfo.Products
                        .filter(p => p != combinedProduct && p.AmountType == 0);

                    selectedProducts.forEach(p => p.Quantity = _this.productQuantity);
                }

                selectedProducts.forEach(function (product) {
                    products.push({
                        ProductId: product.ProductId,
                        ItemQuantity: parseInt(product.Quantity),
                        ItemAmount: parseInt(product.Amount)
                    });
                });
                var data = {
                    ProjectId: _this.checkedProjectId,
                    AdministrativeTip: _this.administrativeTip,
                    Products: products,
                    DonationId: _this.donationInfo.DonationId,
                    DonationPublicId: _this.donationInfo.DonationPublicId,
                    IsDonationUpdatedFromCancelation: _this.isDonationUpdatedFromCancelation,
                    captchaToken: captchaToken
                };
                return data;
            },
            getProgramDescription() {
                var _this = this;
                var project = _this.projects.find(p => p.ProjectId == _this.checkedProjectId);
                if (project) {
                    var projectTitle = project.IsGeneralFund ? project.Title : project.CountryTitle;
                    return _this.phrases.donationBox.countryDescriptionPhrase.replace('[country]', projectTitle);
                }
            },
            getProgramUrlTitle() {
                var _this = this;
                return _this.phrases.countryUrlPhrase;
            },
            addCombinedProductsToProducts() {
                var _this = this;
                var productsList = [];
                var combinedProduct = _this.donationInfo.Products.find(p => p.ProductType == _this.productTypes.combined);
                if (combinedProduct) {
                    return;
                }

                var monthlyProducts = _this.donationInfo.Products.filter(p => p.AmountType == 0);
                var anyAmountProduct = _this.donationInfo.Products.filter(p => p.AmountType == 1);
                var checkedProducts = _this.donationInfo.Products.filter(p => p.Checked);

                var combinedMonthlyProduct = {
                    Amount: monthlyProducts[0].Amount + monthlyProducts[1].Amount,
                    Title: monthlyProducts[0].Title + ' + ' + monthlyProducts[1].Title,
                    Checked: checkedProducts.length > 1,
                    AmountType: 0,
                    PaymentTerm: 1,
                    PhotoOnProfileUrl: monthlyProducts[0].PhotoOnProfileUrl,
                    Quantity: _this.productQuantity,
                    ProductType: _this.productTypes.combined
                }

                if (checkedProducts.length == 2) {
                    _this.donationInfo.Products.forEach(p => p.Checked = false);
                }

                productsList.push(...monthlyProducts);
                productsList.push(combinedMonthlyProduct);
                productsList.push(anyAmountProduct[0]);

                _this.donationInfo.Products = productsList;
            },
            plus() {
                var _this = this;
                _this.productQuantity = parseInt(_this.productQuantity) + 1;
            },
            minus() {
                var _this = this;
                if (_this.productQuantity == 1) {
                    return;
                }
                _this.productQuantity = parseInt(_this.productQuantity) - 1;
            },
            isNumber(event) {
                if (event.key == '.') {
                    event.preventDefault();
                }
                var keyCode = (event.which) ? event.which : event.keyCode;
                if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
                    event.preventDefault();
                    _this.showAnyAmountError = true;
                } else {
                    return true;
                }
            },
            checkQuantity() {
                var _this = this;
                var value = parseInt(_this.productQuantity);

                if (value == 0 || !value) {
                }
                _this.productQuantity = Math.min(9999, Math.max(1, _this.productQuantity));
            },
            checkQuantityInput() {
                var _this = this;
                var value = parseInt(_this.productQuantity);
                if (!value)
                    return;

                _this.checkQuantity();
            },
            unCheckAllProductsExeptChecked(product) {
                var _this = this;
                _this.productQuantity = 1;
                _this.donationInfo.Products.filter(p => p != product && p.AmountType == 0).forEach(p => p.Checked = false);
            },
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            async updateAmount() {
                var _this = this;
                if (_this.sendingUpdateAmountData) return;

                var captchaToken = await window._executeRecaptcha();
                var data = _this.getPostData(captchaToken);
                _this.sendingUpdateAmountData = true;
                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'donation/CreateDonationWithActivePaymentMethod', data)
                    .then((result) => {
                        if (result.success) {
                            _this.sendingUpdateAmountData = false;
                            AlertService.shared.showSuccess('Donation updated successfully');
                            setTimeout(function () {
                                window.location.reload();
                            }, 3000);
                        }
                    })
                    .catch((error) => {
                        _this.sendingUpdateAmountData = false;
                        AlertService.shared.showError(error.data.message);
                    });
            },
        },
        mounted() {
            var _this = this;
            _this.scrollToTop();
            _this.showDonationInfo = true;
            _this.productQuantity = parseInt(_this.productQuantity)
            if (_this.donationInfo) {
                _this.addCombinedProductsToProducts();
                _this.checkedProjectId = _this.donationInfo.ProjectId;
                _this.selectedProductAmountType = _this.getSelectedProductAmountType(_this.donationInfo.Products);
                _this.allProducts = _this.cloneArray(_this.donationInfo.Products);
                _this.administrativeTip = _this.donationInfo.AdministrativeTip;
                _this.activeDonationProductQuantity = _this.productQuantity;
            }

            if (_this.donationPayments && _this.donationPayments.length > 0) {
                _this.showDonationPayments = true;
                _this.showLoadButton();
            }
        },
        computed: {
            totalAmount() {
                var _this = this;
                var totalAmount = _this.totalDonationAmount + (_this.totalDonationAmount * _this.administrativeTip / 100);
                return totalAmount;
            },
            totalDonationAmount() {
                var _this = this;
                var selectedProducts = _this.getSelectedProducts();
                var donationProductTotal = 0;
                for (var i = 0; i < selectedProducts.length; i++) {
                    donationProductTotal += selectedProducts[i].Quantity * selectedProducts[i].Amount;
                }
                return donationProductTotal;
            }
        }
    ,
template: `
    <div class="col-xl-8">
        <!--Donation info-->
        <div class="profile-block js-change-amount-parent" v-if="showDonationInfo">
            <div class="profile-block__head">
                <h3 class="profile-block__title">{{phrases.donationInfo.title}}</h3>
            </div>
            <div class="profile-block__body profile-block__body--overflow-content">
                <div class="profile-block__donation-info" v-if="isUserActiveDonor">
                    <div class="profile-block__donation-info-single">
                        <h6 class="calculator-card__title">{{phrases.donationInfo.monthlyAmountTitle}}</h6>
                        <div class="profile-block__donation-amount">
                            <span class="profile-block__donation-amount-text">$\{{donationInfo.Amount | formatAmount}}</span>
                        </div>
                        <div class="profile-block__actions jcc">
                            <a href="" class="button-action button-action--primary button-action--medium js-change-amount-trigger" @click.prevent="openDonationBox()">{{phrases.donationInfo.updateAmountButton}}</a>
                        </div>
                        <div class="profile-block__infobox-wrap" v-show="false">
                            <div class="profile-block__infobox">
                                <div class="profile-block__infobox-component-wrap">
                                    <svg-icon class="profile-block__infobox-icon" icon="symbol-info"></svg-icon>
                                    <div class="profile-block__infobox-popover">
                                        <div class="profile-block__infobox-popover-clipboard"></div>
                                        <p>{{phrases.donationInfo.descriptionHint}}</p>
                                    </div>
                                </div>
                                <div class="profile-block__infobox-text">
                                    <p>{{phrases.donationInfo.description}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="profile-block__donation-info-single">
                        <div class="profile-block__impact-list" v-if="selectedProductAmountType == 0">
                            <div class="profile-block__impact-item" v-for="product in getSelectedProducts()">
                                <div class="profile-block__impact-icon">
                                    <img :src="product.PhotoOnProfileUrl" alt="">
                                </div>
                                <div class="profile-block__impact-text" v-html="replaceSponsoringProductDescriptionPhrase(product.Title, product.Quantity)">
                                </div>
                            </div>
                        </div>
                        <div class="profile-block__infobox-wrap" v-if="selectedProductAmountType == 1">
                            <div class="profile-block__infobox">
                                <div class="profile-block__infobox-component-wrap">
                                    <svg-icon class="profile-block__infobox-icon" icon="symbol-info"></svg-icon>
                                    <div class="profile-block__infobox-popover">
                                        <div class="profile-block__infobox-popover-clipboard"></div>
                                        <p>{{phrases.donationInfo.descriptionHint}}</p>
                                    </div>
                                </div>
                                <div class="profile-block__infobox-text">
                                    <p>{{phrases.donationInfo.description}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="profile-block__infobox-wrap">
                            <div class="profile-block__infobox">
                                <div class="profile-block__infobox-text">
                                    <p>
                                        {{phrases.donationInfo.donatingProjectDescription}} {{donationInfo.ProjectTitle}}<br>
                                        <a href="" @click.prevent="openProgramPopUp()" class="button-link button-link--default">{{phrases.donationInfo.changeCountryButton}}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profile-block__no-donation" v-if="!isUserActiveDonor">
                    <p class="profile-block__no-donation-text">{{phrases.donationInfo.noDonation}}</p>
                    <a :href="donateUrl" class="button-action button-action--medium button-action--primary">{{phrases.donationInfo.donationButton}}</a>
                </div>
            </div>
        </div>

        <!--Donation box-->
        <div class="profile-block js-change-amount-results" v-if="showDonationBox">
            <div class="profile-block__head">
                <h3 class="profile-block__title">{{phrases.donationBox.title}}</h3>
                <a href="" @click.prevent="closeDonationBox()" class="profile-block__head-action button-link button-link--default js-change-amount-close">
                    <svg-icon class="profile-block__head-action-icon" icon="symbol-caret"></svg-icon>
                    <span class="button-link__text">{{phrases.donationBox.backButton}}</span>
                </a>
            </div>
            <div class="profile-block__body profile-block__body--padded">
                <div class="donation-tabs__body">
                    <div class="donation-options">
                        <donation-product v-for="product in donationInfo.Products"
                                          :product="product"
                                          :show-any-amount-option="isAnyAmountPopupOpened"
                                          :minAmountErrorMessagePhrase="phrases.donationBox.minAmountErrorMessagePhrase"
                                          :product-quantity="productQuantity"
                                          :monthlyCombinedProductHintPhrase="phrases.donationProduct.monthlyCombinedProductHintPhrase"
                                          @hideAnyAmountOption="closeAnyAmountPopup()"
                                          @checkAtLeastOneProduct="checkAtLeastOneProduct($event)"
                                          @unCheckAllProductsExeptChecked="unCheckAllProductsExeptChecked($event)">


                        </donation-product>
                        <!--<div class="donation-options__single--any-amount" v-if="isAnyAmountPopupOpened">
                            <div class="donation-options__any-amount">
                                <div class="donation-options__any-amount-content">
                                    <p>Enter any amount</p>
                                    <div class="donation-options__any-amount-input">
                                        <span>$</span>
                                        <input type="text" maxlength="6">
                                    </div>-->
                        <!--<p class="donation-options__any-amount-hint" v-if="product.AmountSuffix"></p>-->
                        <!--<p class="donation-options__any-amount-hint error"> Minimum amount: 3 USD </p>-->
                        <!--<div class="donation-options__any-amount-text" v-if="product.Hint" v-html="product.Hint"></div>-->
                        <!--</div>
                                <a href="" class="donation-options__any-amount-close js-close-any-amount"
                                   @click.prevent="closeAnyAmountPopup()">
                                    <svg-icon class="donation-options__any-amount-close-icon" icon="symbol-times"></svg-icon>
                                </a>
                            </div>
                        </div>-->
                    </div>

                    <!-- CHOOSE NUMBER OF STUDENTS UPDATE START -->
                    <div class="donation-options__action" v-if="!isAnyAmountPopupOpened">
                        <div class="donation-options__calculator">
                            <p class="donation-options__calculator-title">Choose number of students</p>
                            <div class="calculator-card__calculator">
                                <a class="calculator-card__calculator-action js-calculator-minus"
                                   @click.prevent="minus()">
                                    <svg-icon class="calculator-card__calculator-icon calculator-card__calculator-icon--minus" icon="symbol-minus"></svg-icon>
                                </a>
                                <input type="text" class="calculator-card__calculator-amount"
                                       maxlength="4"
                                       v-model="productQuantity"
                                       @input="checkQuantityInput()"
                                       @keypress="isNumber($event)"
                                       @blur="checkQuantity()">
                                <a class="calculator-card__calculator-action js-calculator-plus"
                                   @click.prevent="plus()">
                                    <svg-icon class="calculator-card__calculator-icon calculator-card__calculator-icon--plus" icon="symbol-plus"></svg-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- CHOOSE NUMBER OF STUDENTS UPDATE END -->

                    <div class="donation-total">
                        <div class="donation-total__sum" v-html="getTotalDonationAmountPhrase()"></div>
                        <div class="donation-total__action" v-show="!isAnyAmountPopupOpened">
                            <p>
                                {{phrases.donationBox.anyAmountText}}<br />
                                <a href="" @click.prevent="openAnyAmountPopup()" class="button-link button-link--default js-open-any-amount">{{phrases.donationBox.anyAmountUrlTitle}}</a>
                            </p>
                        </div>
                        <div class="donation-total__action" v-show="isAnyAmountPopupOpened">
                            <p>
                                <a href="" @click.prevent="closeAnyAmountPopup()" class="button-link button-link--default js-close-any-amount">{{phrases.donationBox.setNOfStudentsUrlTitle}}</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="donation-drag">
                    <h4 class="donation-drag__title">
                        {{phrases.donationBox.allocationTitle}} <span>+{{administrativeTip}}%</span>
                        <div class="donation-options__single-info-wrap">
                            <svg-icon class="donation-options__single-info-icon" icon="symbol-info"></svg-icon>
                            <div class="donation-options__single-info">
                                <div class="donation-options__single-info-clipboard"></div>
                                <p>{{phrases.donationBox.allocationTitleHint}}</p>
                            </div>
                        </div>
                    </h4>
                    <div class="donation-drag__slider-wrap">
                        <div ref="startValue" class="donation-drag__slider-value donation-drag__slider-value--start" id="startValue"><span>0%</span></div>
                        <div ref="allocationrange" class="donation-drag__slider" id="allocationrange"></div>
                        <div ref="endValue" class="donation-drag__slider-value donation-drag__slider-value--end" id="endValue"><span>100%</span></div>
                    </div>
                </div>
                <div class="donation-actions">
                    <a href="" @click.prevent="updateAmount()" class="button-action button-action--primary button-action--medium"
                       v-bind:class="{'loading': sendingUpdateAmountData}" v-html="getTotalAmountPhrase()">
                        <!--<div class="spinner"></div>-->
                    </a>
                    <p class="donation-actions__additional">
                        {{getProgramDescription()}}
                        <a href="" @click.prevent="openProgramPopUp()" class="button-link button-link--default">{{phrases.donationBox.countryUrlTitle}} </a>?
                    </p>
                </div>
            </div>
        </div>

        <!--Donation payments-->
        <div class="profile-block" v-if="showDonationPayments">
            <div class="profile-block__head">
                <h3 class="profile-block__title">{{phrases.donationPayments.title}}</h3>
            </div>
            <div class="profile-block__body">
                <div class="profile-block__payments-list">
                    <div class="table-responsive">
                        <table class="table table-borderless">
                            <thead>
                                <tr>
                                    <th>{{phrases.donationPayments.status}}</th>
                                    <th>{{phrases.donationPayments.date}}</th>
                                    <th>{{phrases.donationPayments.amount}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="isUserActiveDonor" v-bind:class="nextPayment.Status.toLowerCase()">
                                    <td>{{nextPayment.Status}}</td>
                                    <td>{{nextPayment.Date}}</td>
                                    <td>$\{{nextPayment.Amount | formatAmount}}</td>
                                </tr>
                                <tr v-show="donationPayment.Show" v-bind:class="donationPayment.Status.toLowerCase()" v-for="donationPayment in donationPayments">
                                    <td>{{donationPayment.Status}}</td>
                                    <td>{{donationPayment.Date}}</td>
                                    <td>$\{{donationPayment.Amount | formatAmount}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="profile-block__actions jcfe" v-if="showLoadMoreButton">
                    <a href="" @click.prevent="loadMore()" class="button-action button-action--secondary button-action--medium">{{phrases.donationPayments.loadMoreButton}}</a>
                </div>
            </div>
        </div>

        <!--modals-->
        <div class="custom-modal" id="countriesList" style="display: none;">
            <h2 class="custom-modal__title">{{phrases.donationProgram.title}}</h2>
            <div class="countries-list">
                <div class="countries-list__single" v-for="project in projects">
                    <div class="custom-radio">
                        <input v-model="checkedProjectId" :value="project.ProjectId" type="radio" name="counties-list-option" :id="project.ProjectId" class="custom-radio__input">
                        <label :for="project.ProjectId" class="custom-radio__label">
                            <div class="custom-radio__icon-wrap">
                                <span class="custom-radio__icon"></span>
                            </div>
                            <div class="custom-radio__text">
                                <h6 class="custom-radio__title">{{project.Title}}</h6>
                                <p class="custom-radio__description">
                                    {{project.ShortDescription}}
                                </p>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div class="custom-modal__action">
                <a href="" @click.prevent="showDonationBox ? selectProgram() : updateAmount()" class="button-action button-action--medium button-action--secondary"
                   v-bind:class="sendingUpdateAmountData ?'loading' : 'active'">
                    <div class="spinner"></div>{{phrases.donationProgram.button}}
                </a>
            </div>
            <a href="" @click.prevent="closeProgramPopUp()" data-fancybox-close class="custom-modal__close">
                <svg-icon class="custom-modal__close-icon" icon="symbol-times"></svg-icon>
            </a>
        </div>
    </div>
`
});
Vue.component('profile', {
        props: {
            isUserActiveDonor: Boolean,
            changeCardUrl: String,
            renewCardSucceeded: String,
            hasUserActivePaymentMethod: Boolean,
            productQuantity: Number
        },
        data: function () {
            return {
                userData: SettingsService.shared.data.userInfo,
                donationInfo: SettingsService.shared.data.donationInfo,
                paymentMethodInfo: SettingsService.shared.data.paymentMethodInfo,
                bannerDonateUrl: SettingsService.shared.data.donateUrl,
                apiBaseUrl: SettingsService.shared.data.apiBaseUrl,
                activeTab: 0,
                showDonationBox: false,
                showCardInfo: false,
                sendingCancelDonationData: false,
                renewCardSuccess: false,
                sendingUpdateAmountData: false,
                sendingDeletePaymentMethodData: false,
                amount: 1,
                phrases: {
                    paymentsTab: PhrasesService.shared.getPhrase('profile_paymentstab'),
                    profileInfoTab: PhrasesService.shared.getPhrase('profile_infotab'),
                    card: {
                        cardTitle: PhrasesService.shared.getPhrase('profile_cardinfotitle'),
                        changecardbutton: PhrasesService.shared.getPhrase('profile_changecardbutton'),
                        cardChangedSuccessMessage: PhrasesService.shared.getPhrase('profile_cardchangedsuccessmessage'),
                        cardChangedErrorMessage: PhrasesService.shared.getPhrase('profile_cardchangederrormessage'),
                    },
                    donationCancelPopUp: {
                        title: PhrasesService.shared.getPhrase('profile_donationcancelpopuptitle'),
                        description: PhrasesService.shared.getPhrase('profile_donationcancelpopupdescription'),
                        cancelButton: PhrasesService.shared.getPhrase('profile_donationcancelpopupcancelbutton'),
                        updateAmountDescription: PhrasesService.shared.getPhrase('profile_donationcancelpopupupdateamountdescription'),
                        updateAmountButton: PhrasesService.shared.getPhrase('profile_donationcancelpopupupdateamountbutton'),
                        backButton: PhrasesService.shared.getPhrase('profile_donationcancelpopupbackbutton'),
                    },
                    afterDonationCanceledPopUp: {
                        title: PhrasesService.shared.getPhrase('profile_afterdonationcanceledpopuptitle'),
                        subTitle: PhrasesService.shared.getPhrase('profile_afterdonationcanceledpopupsubtitle'),
                        description: PhrasesService.shared.getPhrase('profile_afterdonationcanceledpopupdescription'),
                        button: PhrasesService.shared.getPhrase('profile_afterdonationcanceledpopupbutton'),
                        buttonUrl: PhrasesService.shared.getPhrase('profile_afterdonationcanceledpopupbuttonurl'),
                    },
                    paymentMethod: {
                        paymentMethodTitle: PhrasesService.shared.getPhrase('profile_paymentmethodinfotitle'),
                        changePaymentMethodButton: PhrasesService.shared.getPhrase('profile_changepaymentmethod'),
                        canceldonationbutton: PhrasesService.shared.getPhrase('profile_canceldonationbutton'),
                        paymentMethodChangeSuccessMessage: PhrasesService.shared.getPhrase('profile_paymentmethodchangesuccessmessage'),
                        paymentMethodChangeErrorMessage: PhrasesService.shared.getPhrase('profile_paymentmethodchangeerrormessage'),
                    }
                },
            };
        },
        methods: {
            setActiveTab(tab, hash) {
                var _this = this;
                _this.activeTab = tab;
                window.location.hash = hash;
            },
            showCardInfo() {
                var _this = this;
                return _this.activeTab == 0 && _this.isUserActiveDonor;
            },
            openCancelDonationPopUp() {
                var _this = this;
                //_this.amount = _this.donationInfo.Products.filter(p =>  p.PaymentTerm == 1 && p.AmountType == 1)[0].MinAmount;
                _this.amount = Math.floor(_this.donationInfo.Amount / 2 / 100);
                _this.openPopUp('#cancelDonation');
            },
            openAfterCancelDonationPopUp() {
                var _this = this;
                _this.openPopUp('#afterCancelling');
            },
            openDeletePaymentMethodPopUp() {
                var _this = this;
                _this.openPopUp('#deletePaymentMethod');
            },
            openPopUp(popupId) {
                $.fancybox.open({ src: popupId, modal: true });
            },
            changeCard() {
                var _this = this;
                var redirectUrl = _this.changeCardUrl;
                if (_this.paymentMethodInfo) {
                    redirectUrl += '?id=' + _this.paymentMethodInfo.Id + '&' + 'publicId=' + _this.paymentMethodInfo.PublicId;
                }
                window.location.href = redirectUrl;
            },
            closeAfterCancellingModal() {
                $.fancybox.close();
                location.reload();
            },
            processUrlHash() {
                var _this = this;
                if (window.location.hash.length > 1) {
                    var element = _this.$refs[window.location.hash.substring(1)];
                    if (element)
                        element.click();
                }
            },
            removeQueryFromUrl() {
                window.history.replaceState('', '', window.location.href.split('?')[0]);
            },
            onHashChangeEvent() {
                var _this = this;
                $(window).on('hashchange', function () {
                    _this.processUrlHash();
                });
            },
            showRenewCardResultMessage() {
                var _this = this;
                if (_this.renewCardSucceeded == "true") {
                    AlertService.shared.showSuccess(_this.phrases.paymentMethod.paymentMethodChangeSuccessMessage);
                    _this.removeQueryFromUrl();
                } else if (_this.renewCardSucceeded == "false") {
                    AlertService.shared.showError(_this.phrases.paymentMethod.paymentMethodChangeErrorMessage);
                    _this.removeQueryFromUrl();
                }
            },
            isNumber(event) {
                var keyCode = (event.which) ? event.which : event.keyCode;
                if ((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
                    event.preventDefault();
                } else {
                    return true;
                }
            },
            checkAnyAmount() {
                var _this = this;
                var value = parseInt(_this.amount);
                if (!value) {
                    value = 1;
                }

                var minAmount = Math.floor(_this.donationInfo.Amount / 2 / 100);
                _this.amount = Math.min(999999, Math.max(minAmount, _this.amount));
            },
            openDonationBox() {
                var _this = this;

                if (_this.activeTab == 1)
                    _this.setActiveTab(0);

                _this.$refs.profilePayments.uncheckAllCheckedProducts();
                _this.$refs.profilePayments.donationInfo.Products
                    .filter(p => p.AmountType == 1)
                    .forEach(p => { p.Checked = true; p.Amount = _this.amount });

                _this.$refs.profilePayments.selectedProductAmountType = 1;
                _this.$refs.profilePayments.isDonationUpdatedFromCancelation = true;
                _this.$refs.profilePayments.openDonationBox();
                $.fancybox.close();
            },
            async cancelDonation() {
                var _this = this;
                if (_this.sendingCancelDonationData || _this.sendingUpdateAmountData) return;
                var captchaToken = await window._executeRecaptcha();
                var data = {
                    DonationId: _this.donationInfo.DonationId,
                    DonationPublicId: _this.donationInfo.DonationPublicId,
                    CaptchaToken: captchaToken,
                    Gateway: _this.paymentMethodInfo.GatewayService
                };
                _this.sendingCancelDonationData = true;
                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'donation/canceldonation', data)
                    .then((result) => {
                        _this.sendingCancelDonationData = false;
                        if (result.success) {
                            $.fancybox.close();
                            _this.isUserActiveDonor = false;
                            _this.openPopUp('#afterCancelling');
                        }
                    })
                    .catch((error) => {
                        _this.sendingCancelDonationData = false;
                        $.fancybox.close();
                        AlertService.shared.showError(error.data.message)
                        /*   _this.showErrorPopUp(error.data.message);*/
                    });
            },
            async deletePaymentMethod() {
                var _this = this;
                var captchaToken = await window._executeRecaptcha();
                var data = {
                    CaptchaToken: captchaToken,
                    PaymentMethodId: _this.paymentMethodInfo.Id,
                    PaymentMethodPublicId: _this.paymentMethodInfo.PublicId,
                    Gateway: _this.paymentMethodInfo.GatewayService
                };
                _this.sendingDeletePaymentMethodData = true;
                await ApiService.shared._makeHttpDataPostRequest(_this.apiBaseUrl, 'donation/deletepaymentmethod', data)
                    .then((result) => {
                        _this.sendingDeletePaymentMethodData = false;
                        if (result.success) {
                            AlertService.shared.showSuccess("Payment Method Delete Successfuly");
                            location.reload();
                        }
                    })
                    .catch((error) => {
                        _this.sendingDeletePaymentMethodData = false;
                        AlertService.shared.showError(error.data.message)
                    });
            }
        },
        mounted() {
            var _this = this;
            _this.processUrlHash();
            _this.onHashChangeEvent();
            _this.showRenewCardResultMessage();
            _this.bannerDonateUrl += '#bundle'
        }
    ,
template: `
    <section class="section section--smallpadding">
        <div class="container">
            <div class="switcher switcher--primary">
                <div class="switcher__content">
                    <a href="" class="switcher__item"
                       ref="payments"
                       v-bind:class="{'active' : activeTab == 0}"
                       @click.prevent="setActiveTab(0, 'payments')">{{phrases.paymentsTab}}</a>

                    <a href="" class="switcher__item"
                       ref="info"
                       v-bind:class="{'active' : activeTab == 1}"
                       @click.prevent="setActiveTab(1, 'info')">{{phrases.profileInfoTab}}</a>
                </div>
            </div>
            <div class="profile">
                <div class="profile__row row">
                    <profile-payments ref="profilePayments" v-if="activeTab == 0"
                                      :is-user-active-donor="isUserActiveDonor"
                                      :product-quantity="productQuantity">
                    </profile-payments>
                    <profile-info v-if="activeTab == 1">
                    </profile-info>

                    <div class="col-xl-4" v-if="hasUserActivePaymentMethod">
                        <div class="profile-block profile-block--borderless">
                            <div class="profile-block__head">
                                <h3 class="profile-block__title">{{phrases.paymentMethod.paymentMethodTitle}}</h3>
                                <a href="#" @click.prevent="changeCard()" class="button-link button-link--default">{{phrases.paymentMethod.changePaymentMethodButton}}</a>
                            </div>
                            <div class="profile-block__body">
                                <!--Payment Method Card-->
                                <div class="profile-block__credit-card" v-if="paymentMethodInfo.paymentGatewayPaymentMethodType == 10">
                                    <img src="~/m/i/card.png" alt="">
                                    <p class="profile-block__credit-card-number">**** **** **** {{paymentMethodInfo.Pan}}</p>
                                </div>

                                <!--Payment Method PayPal Account-->
                                <div class="profile-block__paypal" v-if="paymentMethodInfo.paymentGatewayPaymentMethodType == 20">
                                    <div class="profile-block__paypal-image">
                                        <img src="~/m/i/paypal.png" alt="" />
                                    </div>
                                    <div class="profile-block__paypal-info">
                                        <h5 class="profile-block__paypal-key">Email</h5>
                                        <p class="profile-block__paypal-value"> {{paymentMethodInfo.PaymentGatewayCustomerEmail}}</p>
                                    </div>
                                </div>

                                <!--Payment Method Apple Pay-->
                                <div class="profile-block__paypal" v-if="paymentMethodInfo.paymentGatewayPaymentMethodType == 40">
                                    <div class="profile-block__paypal-image">
                                        <img src="~/m/i/applepay.png" alt="" />
                                    </div>
                                    <div class="profile-block__paypal-info">
                                        <h5 class="profile-block__paypal-key">Card Number</h5>
                                        <p class="profile-block__paypal-value"> **** {{paymentMethodInfo.Pan}}</p>
                                    </div>
                                </div>

                                <!--Payment Method GPay-->
                                <div class="profile-block__paypal" v-if="paymentMethodInfo.paymentGatewayPaymentMethodType == 50">
                                    <div class="profile-block__paypal-image">
                                        <img src="~/m/i/gpay.png" alt="" />
                                    </div>
                                    <div class="profile-block__paypal-info">
                                        <h5 class="profile-block__paypal-key">Card Number</h5>
                                        <p class="profile-block__paypal-value"> **** {{paymentMethodInfo.Pan}}</p>
                                    </div>
                                </div>

                                <!--Payment Method Link-->
                                <div class="profile-block__paypal" v-if="paymentMethodInfo.paymentGatewayPaymentMethodType == 60">
                                    <div class="profile-block__paypal-image">
                                        <img src="~/m/i/link.png" alt="" />
                                    </div>
                                    <div class="profile-block__paypal-info">
                                        <h5 class="profile-block__paypal-key">Card Number</h5>
                                        <p class="profile-block__paypal-value"> **** {{paymentMethodInfo.Pan}}</p>
                                    </div>
                                </div>

                                <div class="profile-block__actions jcsb" v-if="isUserActiveDonor">
                                    <!-- <a href="" @click.prevent="changeCard()" class="button-link button-link--default">{{phrases.paymentMethod.changePaymentMethodbutton}}</a>-->
                                    <a href="" @click.prevent="openCancelDonationPopUp()" class="button-link button-link--default">{{phrases.paymentMethod.canceldonationbutton}}</a>
                                </div>
                                <div class="profile-block__actions jcsb" v-if="hasUserActivePaymentMethod && !isUserActiveDonor">
                                    <a href="" @click.prevent="openDeletePaymentMethodPopUp()" class="button-link button-link--default">Delete Payment Method</a>
                                </div>
                            </div>
                        </div>

                        <div class="rek__list">
                            <a :href="bannerDonateUrl" class="rek">
                                <img src="~/m/u/rek/onetime-donation-banner.jpg" alt="">
                            </a>
                            <!--<a href="" target="_blank" class="rek">
                            <img src="~/m/u/rek/2.jpg" alt="">
                        </a>-->
                        </div>

                        <!--<div class="profile-block profile-block--borderless">
                        <div class="profile-block__head">
                            <h3 class="profile-block__title">Payment method</h3>
                            <a href="#" class="button-link button-link--default">Change</a>
                        </div>
                        <div class="profile-block__body">
                            <div class="profile-block__paypal">
                                <div class="profile-block__paypal-image">
                                    <img src="~/m/i/paypal.png" alt="" />
                                </div>
                                <div class="profile-block__paypal-info">
                                    <h5 class="profile-block__paypal-key">Email</h5>
                                    <p class="profile-block__paypal-value">kh.apkhaidze@gmail.com</p>
                                </div>
                            </div>
                            <div class="profile-block__actions">
                                <a href="#" class="button-link button-link--default">Cancel donation</a>
                            </div>
                        </div>
                    </div>-->
                        <!--<div class="rek__list" v-show="false">
                        <a href="" target="_blank" class="rek">
                            <img src="~/m/u/rek/1.jpg" alt="">
                        </a>
                        <a href="" target="_blank" class="rek">
                            <img src="~/m/u/rek/2.jpg" alt="">
                        </a>
                    </div>-->
                    </div>
                </div>
            </div>
        </div>

        <!--Cancel Donation Modal-->
        <div class="custom-modal" id="cancelDonation" style="display: none;">
            <h2 class="custom-modal__title">{{phrases.donationCancelPopUp.title}}</h2>
            <div class="cancel-donation">
                <p class="cancel-donation__text" v-html="phrases.donationCancelPopUp.description"></p>
                <a href="" ref="cancleDonation" @click.prevent="cancelDonation()" class="button-action button-action--medium button-action--danger"
                   v-bind:class="{'loading' : sendingCancelDonationData}">
                    <div class="spinner"></div>
                    {{phrases.donationCancelPopUp.cancelButton}}
                </a>
            </div>
            <div class="update-amount">
                <p class="update-amount__text">{{phrases.donationCancelPopUp.updateAmountDescription}}</p>
                <div class="profile-block__actions jcc">
                    <input type="text" class="cancel-donation__field"
                           v-model="amount"
                           maxlength="6"
                           @keypress="isNumber($event)"
                           @blur="checkAnyAmount()" />
                    <a href="" @click.prevent="openDonationBox()" class="button-action button-action--primary button-action--medium"
                       v-bind:class="{'loading': sendingUpdateAmountData}">
                        <div class="spinner"></div>
                        {{phrases.donationCancelPopUp.updateAmountButton}}
                    </a>
                </div>
            </div>
            <div class="custom-modal__action">
                <a href="" data-fancybox-close class="button-link button-link--default">{{phrases.donationCancelPopUp.backButton}}</a>
            </div>
            <a href="" data-fancybox-close class="custom-modal__close">
                <svg-icon class="custom-modal__close-icon" icon="symbol-times"></svg-icon>
            </a>
        </div>

        <!--After Cancelling Modal-->
        <div class="custom-modal" id="afterCancelling" style="display: none;">
            <div class="custom-modal__message custom-modal__message--success">
                <div class="custom-modal__message-icon-wrap">
                    <div class="custom-modal__message-icon-bg">
                        <svg-icon class="custom-modal__message-icon" icon="symbol-checkbox-round"></svg-icon>
                    </div>
                </div>
                <h3 class="custom-modal__message-text">{{phrases.afterDonationCanceledPopUp.title}}</h3>
            </div>
            <div class="custom-modal__text">
                <p>{{phrases.afterDonationCanceledPopUp.subTitle}}</p>
            </div>
            <div class="custom-modal__after-cancel">
                <p>{{phrases.afterDonationCanceledPopUp.description}}</p>
            </div>
            <div class="custom-modal__action">
                <a :href="phrases.afterDonationCanceledPopUp.buttonUrl" target="_blank" class="button-action button-action--large button-action--primary">{{phrases.afterDonationCanceledPopUp.button}}</a>
            </div>
            <a href="" @click.prevent="closeAfterCancellingModal()" data-fancybox-close class="custom-modal__close">
                <svg-icon class="custom-modal__close-icon" icon="symbol-times"></svg-icon>
            </a>
        </div>

        <!--Delete Payment Method Modal-->
        <div class="custom-modal" id="deletePaymentMethod" style="display: none;">
            <h2 class="custom-modal__title">Delete Payment Method</h2>
            <div class="cancel-donation">
                <p class="cancel-donation__text">Are you sure you want to delete this payment method?</p>
                <a href="" ref="cancleDonation" @click.prevent="deletePaymentMethod()" class="button-action button-action--medium button-action--danger"
                   v-bind:class="{'loading' : sendingDeletePaymentMethodData}">
                    <div class="spinner"></div>
                    Delete
                </a>
            </div>
            <div class="custom-modal__action">
                <a href="" data-fancybox-close class="button-link button-link--default">Back</a>
            </div>
            <a href="" data-fancybox-close class="custom-modal__close">
                <svg-icon class="custom-modal__close-icon" icon="symbol-times"></svg-icon>
            </a>
        </div>
    </section>
`
});
Vue.component('svg-icon', {
        props: ['icon'],
        data: function () {
            return {
                local: {},
                baseUrl: SettingsService.shared.data.baseUrl
            };
        },
        methods: {
            getIconUrl: function () {
                return this.baseUrl + 'm/i/icons.svg#' + this.icon;
            }
        },
        mounted() {
        }
    ,
template: `
    <svg v-once><use v-bind="{\'xlink:href\' : getIconUrl()}" /></svg>
`
});
(function (target) {
    Vue.prototype.$settings = SettingsService.shared;
    Vue.prototype.$analytics = AnalyticsService.shared;
    Vue.prototype.$alert = AlertService.shared;
    Vue.$alert = AlertService.shared;
    var vueAppContainers = document.querySelectorAll('*[data-vue-app]');

    [].forEach.call(vueAppContainers, function (vueAppContainer) {
        new Vue({
            el: vueAppContainer
        });
    });
})(window);
svg4everybody();

(function () {

    $(window).on('load, scroll', function () {
        var scroll = $(window).scrollTop();
        (scroll >= 80) ? $('.header').toggleClass('scrolled', true) : $('.header').toggleClass('scrolled', false);
        (scroll >= 80) ? $('.announcement').toggleClass('scrolled', true) : $('.announcement').toggleClass('scrolled', false);
        (scroll >= 80) ? $('body').toggleClass('scrolled', true) : $('body').toggleClass('scrolled', false);
    });

    $('.js-trigger').on('click', function () {
        var _trigger = $(this);
        var _results = $(this).siblings('.js-results');
        _trigger.parent().toggleClass('open');
        _results.stop().slideToggle();
        $('.js-trigger').not(_trigger).parent().removeClass('open');
        $('.js-results').not(_results).slideUp();
        return false;
    });

    $('.responsive-menu .js-responsive-submenu-trigger').on('click', function () {
        var _trigger = $(this);
        var _results = $(this).siblings('.js-responsive-submenu-results');
        _trigger.parent().toggleClass('open');
        _results.stop().slideToggle();
        $('.js-responsive-submenu-trigger').not(_trigger).parent().removeClass('open');
        $('.js-responsive-submenu-results').not(_results).slideUp();
        return false;
    });

    $('.js-responsive-menu-trigger').on('click', function () {
        if (window._isIntro) {
            return false;
        }
        $(this).parents('.header__burger').toggleClass('open');
        $(this).parents('.header__burger').siblings('.responsive-menu').toggleClass('open');
        $('body').toggleClass('noscroll');
        $('html').toggleClass('noscroll');
        return false;
    });

    $(document).on('click', function (e) {
        var $trigger = $('.js-trigger');
        if ($trigger !== e.target && !$trigger.has(e.target).length) {
            $('.js-trigger').parent().removeClass('open');
            $('.js-results').slideUp();
        }
    });

    $('.responsive-menu__content').on('click', function (e) {
        return e.target != e.currentTarget;
    });

    $(document).on('click', function (e) {
        if ($('.intro').is(':visible')) {
            return false;
        }
        
        var $menu = $('.responsive-menu__content');
        if ($menu !== e.target && !$menu.has(e.target).lenght) {
            $('.js-responsive-menu-trigger').parents('.header__burger').removeClass('open')
            $('.js-responsive-menu-trigger').parents('.header__burger').siblings('.responsive-menu').removeClass('open');
            $('body').removeClass('noscroll');
            $('html').removeClass('noscroll');
        }
    });

    //-------------------
    var breakpoint = window.matchMedia('(min-width: 1200px)');
    let destroyableSwiper = [];
    var breakpointChecker = function () {
        if (breakpoint.matches === true) {
            if (destroyableSwiper == undefined) return;
            destroyableSwiper.forEach(function (item) {
                item.destroy(true, true);
            });
        } else if (breakpoint.matches === false) {
            return enableSwiper();
        }
    };
    var enableSwiper = function () {
        $('.js-responsive-slider .swiper-container').each(function () {
            var $elem = $(this);
            var $paginationElem = $elem.parents('.js-responsive-slider').find('.swiper-pagination');
            destroyableSwiper.push(new Swiper($elem[0], {
                slidesPerView: 'auto',
                spaceBetween: 10,
                loop: true,
                pagination: {
                    el: $paginationElem[0],
                    clickable: true
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    }
                }
            }));
        });
    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
    //-------------------

})();

// ReCaptcha
(function (target) {
    var widgetId = null;
    var recaptchaId = "gi_igrc";
    var latestPromise = null;

    var renderWait = function () {
        setTimeout(function () {
            if (typeof grecaptcha !== 'undefined' && grecaptcha.render) {
                render();
            }
            else {
                renderWait();
            }
        }, 200);
    }

    var render = function () {
        widgetId = grecaptcha.render(recaptchaId, {
            sitekey: window._data.reCaptchaSiteKey,
            size: 'invisible',
            badge: "bottomright",
            theme: "dark",
            callback: function (token) {
                latestPromise.resolve(token);
                grecaptcha.reset(widgetId);
            }
        });

        target._executeRecaptcha = function () {
            if (latestPromise != null) {
                latestPromise.reject();
            }

            var resolveCallback = null;
            var rejectCallback = null;

            latestPromise = new Promise(function (resolve, reject) {
                resolveCallback = resolve;
                rejectCallback = reject;
            });
            latestPromise.resolve = resolveCallback;
            latestPromise.reject = rejectCallback;

            grecaptcha.execute();
            return latestPromise;
        }
    }

    $(document.body).append('<div id="' + recaptchaId + '" class="g-recaptcha"></div>');

    var script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
    script.onload = renderWait;
    document.head.appendChild(script);
})(window);

$(function () {
    if (!window.location.hash || window.location.hash.length < 2) {
        return;
    }


    var anchorElem = document.getElementById(window.location.hash.substr(1));
    if (!anchorElem) {
        return;
    }

    window.scrollTo(0, window.scrollY - 70);
});


(function (target) {
    target._stats = {};

    var sendGaEvent = function (eventName, evetData) {
        //if (window.ga) {
        //    ga('send', {
        //        hitType: 'event',
        //        eventCategory: eventName,
        //        eventAction: eventName
        //    });
        //};
    
        if (window.gtag) {
            gtag('event', eventName, evetData);
        };
    }

    var sendFbEvent = function (eventName, evetData) {
        if (window.fbq) {
            fbq('trackCustom', eventName, evetData);
        }
    }


    target._stats.send = function (eventName, evetData) {
        evetData = evetData || {};

        setTimeout(function () {
            sendGaEvent(eventName, evetData);
        });
        setTimeout(function () {
            sendFbEvent(eventName, evetData);
        });
    }
})(window);

